webpackJsonp([1],{

/***/ "+0L8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container accord24",
    staticStyle: {
      "width": "894px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("CERTIFICATE OF PROPERTY INSURANCE")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "piece"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          " + _vm._s(_vm.currentDate) + "\n        ")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-size": "8px",
      "font-weight": "bold",
      "margin-top": "-10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5",
      "colspan": "6",
      "width": "50%"
    }
  }, [_vm._v("\n          PRODUCER\n          "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.Producer),
      expression: "accord24.Producer"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "type": "text",
      "colspan": "6"
    },
    domProps: {
      "value": (_vm.accord24.Producer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "Producer", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.Producer))
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n          CONTACT\n          "), _c('br'), _vm._v("NAME:\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.ContactName),
      expression: "accord24.ContactName"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.ContactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "ContactName", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.ContactName) + " ")]) : _vm._e()])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            PHONE\n            "), _c('br'), _vm._v("(A/C,NO,Ext):\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.PhoneNumber),
      expression: "accord24.PhoneNumber"
    }],
    staticClass: "lg-60",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.PhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "PhoneNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.PhoneNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            FAX\n            "), _c('br'), _vm._v("(A/C,No):\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.FaxNumber),
      expression: "accord24.FaxNumber"
    }],
    staticClass: "lg-40",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.FaxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "FaxNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.FaxNumber) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n            E-MAIL\n            "), _c('br'), _vm._v("ADDRESS:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.ContactEmailAddress),
      expression: "accord24.ContactEmailAddress"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.ContactEmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "ContactEmailAddress", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.ContactEmailAddress) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n            PRODUCER\n            "), _c('br'), _vm._v("CUSTOMER ID:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.ProducerCustomerId),
      expression: "accord24.ProducerCustomerId"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.ProducerCustomerId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "ProducerCustomerId", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.ProducerCustomerId) + " ")]) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6",
      "colspan": "6"
    }
  }, [_vm._v("\n            INSURED\n            "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.Insured),
      expression: "accord24.Insured"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.Insured)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "Insured", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.Insured))
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER A:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerA_Name),
      expression: "accord24.InsurerA_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerA_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerA_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerA_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerA_NAIC),
      expression: "accord24.InsurerA_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerA_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerA_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.FaxNumber) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER B:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerB_Name),
      expression: "accord24.InsurerB_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerB_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerB_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerB_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerB_NAIC),
      expression: "accord24.InsurerB_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerB_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerB_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerB_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER C:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerC_Name),
      expression: "accord24.InsurerC_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerC_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerC_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerC_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerC_NAIC),
      expression: "accord24.InsurerC_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerC_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerC_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerC_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER D:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerD_Name),
      expression: "accord24.InsurerD_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerD_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerD_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerD_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerD_NAIC),
      expression: "accord24.InsurerD_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerD_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerD_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerD_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER E:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerE_Name),
      expression: "accord24.InsurerE_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerE_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerE_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerE_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerE_NAIC),
      expression: "accord24.InsurerE_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerE_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerE_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerE_NAIC) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER F:\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerF_Name),
      expression: "accord24.InsurerF_Name"
    }],
    staticClass: "lg-70",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerF_Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerF_Name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerF_Name) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerF_NAIC),
      expression: "accord24.InsurerF_NAIC"
    }],
    staticClass: "lg-80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerF_NAIC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerF_NAIC", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerF_NAIC) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "id": "middle_part"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": " 30%"
    }
  }, [_vm._v("\n          COVERAGES\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("\n          CERTIFICATE NUMBER:\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.CertificateNumber),
      expression: "accord24.CertificateNumber"
    }],
    staticClass: "lg",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.CertificateNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "CertificateNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.CertificateNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("\n          REVISION NUMBER:\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.RevisionNumber),
      expression: "accord24.RevisionNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.RevisionNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "RevisionNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.RevisionNumber) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    staticClass: "content3",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("\n          LOCATION OF PREMISES/DESCRIPTION OF PROPERTY (Use Additional Remarks, if more space is required)\n          "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.PropertyDescription),
      expression: "accord24.PropertyDescription"
    }],
    staticClass: "lg md-textarea",
    attrs: {
      "data-limit-rows": "true",
      "rows": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.PropertyDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "PropertyDescription", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.PropertyDescription))
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "11",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1),
      expression: "accord24.InsurerLetter1"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "line-height": "17px"
    },
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsProperty),
      expression: "accord24.InsurerLetter1_IsProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsProperty)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("CAUSES OF LOSS")])]), _vm._v(" "), _c('td', {
    staticClass: "rmbt",
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "10",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_PolicyNumber),
      expression: "accord24.InsurerLetter1_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "10",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_EffectiveDate),
      expression: "accord24.InsurerLetter1_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "10",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_ExpirationDate),
      expression: "accord24.InsurerLetter1_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBuilding),
      expression: "accord24.InsurerLetter1_IsBuilding"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBuilding) ? _vm._i(_vm.accord24.InsurerLetter1_IsBuilding, null) > -1 : (_vm.accord24.InsurerLetter1_IsBuilding)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBuilding,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBuilding = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBuilding = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBuilding", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBuilding)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" BUILDING")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BuildingLimits),
      expression: "accord24.InsurerLetter1_BuildingLimits"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BuildingLimits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BuildingLimits", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BuildingLimits) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rmtop",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          DEDUCTIBLES\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsPersonalProperty),
      expression: "accord24.InsurerLetter1_IsPersonalProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsPersonalProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsPersonalProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsPersonalProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsPersonalProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsPersonalProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsPersonalProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsPersonalProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsPersonalProperty)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" PERSONAL PROPERTY")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_PersonalPropertyLimit),
      expression: "accord24.InsurerLetter1_PersonalPropertyLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_PersonalPropertyLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_PersonalPropertyLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_PersonalPropertyLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBasic),
      expression: "accord24.InsurerLetter1_IsBasic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBasic) ? _vm._i(_vm.accord24.InsurerLetter1_IsBasic, null) > -1 : (_vm.accord24.InsurerLetter1_IsBasic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBasic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBasic = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBasic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBasic", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBasic)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BASIC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [_vm._v("\n          BUILDING\n          "), _c('br'), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BuildingDeductible),
      expression: "accord24.InsurerLetter1_BuildingDeductible"
    }],
    staticStyle: {
      "height": "15px",
      "width": "60px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BuildingDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BuildingDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BuildingDeductible) + " ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" CONTENTS\n          "), _c('br'), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_ContentsDeductible),
      expression: "accord24.InsurerLetter1_ContentsDeductible"
    }],
    staticStyle: {
      "height": "15px",
      "width": "60px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_ContentsDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_ContentsDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_ContentsDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBusinessIncome),
      expression: "accord24.InsurerLetter1_IsBusinessIncome"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBusinessIncome) ? _vm._i(_vm.accord24.InsurerLetter1_IsBusinessIncome, null) > -1 : (_vm.accord24.InsurerLetter1_IsBusinessIncome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBusinessIncome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBusinessIncome = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBusinessIncome = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBusinessIncome", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBusinessIncome)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BUSINESS INCOME")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BusinessIncomeLimit),
      expression: "accord24.InsurerLetter1_BusinessIncomeLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BusinessIncomeLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BusinessIncomeLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BusinessIncomeLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBroad),
      expression: "accord24.InsurerLetter1_IsBroad"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBroad) ? _vm._i(_vm.accord24.InsurerLetter1_IsBroad, null) > -1 : (_vm.accord24.InsurerLetter1_IsBroad)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBroad,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBroad = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBroad = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBroad", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBroad)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" BROAD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsExtraExpense),
      expression: "accord24.InsurerLetter1_IsExtraExpense"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsExtraExpense) ? _vm._i(_vm.accord24.InsurerLetter1_IsExtraExpense, null) > -1 : (_vm.accord24.InsurerLetter1_IsExtraExpense)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsExtraExpense,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsExtraExpense = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsExtraExpense = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsExtraExpense", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsExtraExpense)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("EXTRA EXPENSE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_ExtraExpenseLimit),
      expression: "accord24.InsurerLetter1_ExtraExpenseLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_ExtraExpenseLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_ExtraExpenseLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_ExtraExpenseLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsSpecial),
      expression: "accord24.InsurerLetter1_IsSpecial"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsSpecial) ? _vm._i(_vm.accord24.InsurerLetter1_IsSpecial, null) > -1 : (_vm.accord24.InsurerLetter1_IsSpecial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsSpecial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsSpecial = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsSpecial = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsSpecial", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsSpecial)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" SPECIAL")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsRentalValue),
      expression: "accord24.InsurerLetter1_IsRentalValue"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsRentalValue) ? _vm._i(_vm.accord24.InsurerLetter1_IsRentalValue, null) > -1 : (_vm.accord24.InsurerLetter1_IsRentalValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsRentalValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsRentalValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsRentalValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsRentalValue", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsRentalValue)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("RENTAL VALUE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_RentalValueLimit),
      expression: "accord24.InsurerLetter1_RentalValueLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_RentalValueLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_RentalValueLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_RentalValueLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsEarthquake),
      expression: "accord24.InsurerLetter1_IsEarthquake"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsEarthquake) ? _vm._i(_vm.accord24.InsurerLetter1_IsEarthquake, null) > -1 : (_vm.accord24.InsurerLetter1_IsEarthquake)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsEarthquake,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsEarthquake = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsEarthquake = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsEarthquake", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsEarthquake)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" EARTHQUAKE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_EarthquakeDeductible),
      expression: "accord24.InsurerLetter1_EarthquakeDeductible"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_EarthquakeDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_EarthquakeDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_EarthquakeDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBlanketBuilding),
      expression: "accord24.InsurerLetter1_IsBlanketBuilding"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBlanketBuilding) ? _vm._i(_vm.accord24.InsurerLetter1_IsBlanketBuilding, null) > -1 : (_vm.accord24.InsurerLetter1_IsBlanketBuilding)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBlanketBuilding,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBlanketBuilding = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBlanketBuilding = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBlanketBuilding", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBlanketBuilding)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BLANKET BUILDING")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BlanketBuildingLimit),
      expression: "accord24.InsurerLetter1_BlanketBuildingLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BlanketBuildingLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BlanketBuildingLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BlanketBuildingLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsWind),
      expression: "accord24.InsurerLetter1_IsWind"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsWind) ? _vm._i(_vm.accord24.InsurerLetter1_IsWind, null) > -1 : (_vm.accord24.InsurerLetter1_IsWind)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsWind,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsWind = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsWind = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsWind", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsWind)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("WIND")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_WindDeductible),
      expression: "accord24.InsurerLetter1_WindDeductible"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_WindDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_WindDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_WindDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty),
      expression: "accord24.InsurerLetter1_IsBlanketPersonalProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBlanketPersonalProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBlanketPersonalProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBlanketPersonalProperty)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BLANKET PERS PROP")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BlanketPersonalPropertyLimits),
      expression: "accord24.InsurerLetter1_BlanketPersonalPropertyLimits"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BlanketPersonalPropertyLimits)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BlanketPersonalPropertyLimits", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BlanketPersonalPropertyLimits) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsFlood),
      expression: "accord24.InsurerLetter1_IsFlood"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsFlood) ? _vm._i(_vm.accord24.InsurerLetter1_IsFlood, null) > -1 : (_vm.accord24.InsurerLetter1_IsFlood)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsFlood,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsFlood = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsFlood = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsFlood", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsFlood)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" FLOOD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_FloodDeductible),
      expression: "accord24.InsurerLetter1_FloodDeductible"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_FloodDeductible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_FloodDeductible", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_FloodDeductible) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty),
      expression: "accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty) ? _vm._i(_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty, null) > -1 : (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsBlanketBuildingAndPersonalProperty", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsBlanketBuildingAndPersonalProperty)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("BLANKET BLDG & PP")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit),
      expression: "accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherInsurance1),
      expression: "accord24.InsurerLetter1_IsOtherInsurance1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherInsurance1) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherInsurance1, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherInsurance1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherInsurance1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherInsurance1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherInsurance1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherInsurance1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherInsurance1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherInsurance1),
      expression: "accord24.InsurerLetter1_OtherInsurance1"
    }],
    staticStyle: {
      "width": "60px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherInsurance1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherInsurance1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherInsurance1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherDeductible1),
      expression: "accord24.InsurerLetter1_OtherDeductible1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherDeductible1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherDeductible1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherDeductible1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherProperty1),
      expression: "accord24.InsurerLetter1_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherProperty1),
      expression: "accord24.InsurerLetter1_OtherProperty1"
    }],
    staticStyle: {
      "width": "100px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter1_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherInsurance2),
      expression: "accord24.InsurerLetter1_IsOtherInsurance2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherInsurance2) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherInsurance2, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherInsurance2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherInsurance2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherInsurance2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherInsurance2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherInsurance2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherInsurance2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherInsurance2),
      expression: "accord24.InsurerLetter1_OtherInsurance2"
    }],
    staticStyle: {
      "width": "60px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherInsurance2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherInsurance2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherInsurance2) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherDeductible2),
      expression: "accord24.InsurerLetter1_OtherDeductible2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherDeductible2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherDeductible2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherDeductible2) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_IsOtherProperty2),
      expression: "accord24.InsurerLetter1_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter1_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter1_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter1_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter1_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter1_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter1_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter1_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter1_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherProperty2),
      expression: "accord24.InsurerLetter1_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherProperty2) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter1_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter1_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter1_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter1_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter1_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "5",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2),
      expression: "accord24.InsurerLetter2"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsInlandMarine),
      expression: "accord24.InsurerLetter2_IsInlandMarine"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsInlandMarine) ? _vm._i(_vm.accord24.InsurerLetter2_IsInlandMarine, null) > -1 : (_vm.accord24.InsurerLetter2_IsInlandMarine)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsInlandMarine,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsInlandMarine = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsInlandMarine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsInlandMarine", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsInlandMarine)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v("CAUSES OF LOSS")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('td', {
    staticClass: "rmbt",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          TYPE OF POLICY\n        ")]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "4",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_EffectiveDate),
      expression: "accord24.InsurerLetter2_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "4",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_ExpirationDate),
      expression: "accord24.InsurerLetter2_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "rmbottom",
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty1),
      expression: "accord24.InsurerLetter2_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty1),
      expression: "accord24.InsurerLetter2_OtherProperty1"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("$\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "rmtop",
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_PolicyType),
      expression: "accord24.InsurerLetter2_PolicyType"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_PolicyType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_PolicyType", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_PolicyType) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty2),
      expression: "accord24.InsurerLetter2_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty2),
      expression: "accord24.InsurerLetter2_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("$\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsNamedPerils),
      expression: "accord24.InsurerLetter2_IsNamedPerils"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsNamedPerils) ? _vm._i(_vm.accord24.InsurerLetter2_IsNamedPerils, null) > -1 : (_vm.accord24.InsurerLetter2_IsNamedPerils)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsNamedPerils,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsNamedPerils = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsNamedPerils = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsNamedPerils", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsNamedPerils)) + " ")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "con"
  }, [_vm._v(" NAMED PERILS")])]), _vm._v(" "), _c('td', {
    staticClass: "rmbt",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          POLICY NUMBER\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty3),
      expression: "accord24.InsurerLetter2_IsOtherProperty3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty3) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty3, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty3", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_IsOtherProperty3) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty3),
      expression: "accord24.InsurerLetter2_OtherProperty3"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty3) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("$\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit3),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit3"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit3) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherInsurance4),
      expression: "accord24.InsurerLetter2_IsOtherInsurance4"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherInsurance4) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherInsurance4, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherInsurance4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherInsurance4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherInsurance4 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherInsurance4 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherInsurance4", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherInsurance4)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherInsurance4),
      expression: "accord24.InsurerLetter2_OtherInsurance4"
    }],
    staticStyle: {
      "width": "100px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherInsurance4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherInsurance4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherInsurance4) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "rmtop",
    attrs: {
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_PolicyNumber),
      expression: "accord24.InsurerLetter2_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_IsOtherProperty4),
      expression: "accord24.InsurerLetter2_IsOtherProperty4"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter2_IsOtherProperty4) ? _vm._i(_vm.accord24.InsurerLetter2_IsOtherProperty4, null) > -1 : (_vm.accord24.InsurerLetter2_IsOtherProperty4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter2_IsOtherProperty4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter2_IsOtherProperty4 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter2_IsOtherProperty4 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter2_IsOtherProperty4", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter2_IsOtherProperty4)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherProperty4),
      expression: "accord24.InsurerLetter2_OtherProperty4"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherProperty4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherProperty4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherProperty4) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("$\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter2_OtherPropertyLimit4),
      expression: "accord24.InsurerLetter2_OtherPropertyLimit4"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter2_OtherPropertyLimit4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter2_OtherPropertyLimit4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter2_OtherPropertyLimit4) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3),
      expression: "accord24.InsurerLetter3"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsCrime),
      expression: "accord24.InsurerLetter3_IsCrime"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsCrime) ? _vm._i(_vm.accord24.InsurerLetter3_IsCrime, null) > -1 : (_vm.accord24.InsurerLetter3_IsCrime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsCrime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsCrime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsCrime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsCrime", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsCrime)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "spn"
  }, [_vm._v("TYPE OF POLICY")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_PolicyType),
      expression: "accord24.InsurerLetter3_PolicyType"
    }],
    staticStyle: {
      "width": "120px",
      "height": "20px",
      "padding-left": "3px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_PolicyType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_PolicyType", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_PolicyType) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_PolicyNumber),
      expression: "accord24.InsurerLetter3_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_EffectiveDate),
      expression: "accord24.InsurerLetter3_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "3",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_ExpirationDate),
      expression: "accord24.InsurerLetter3_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsOtherProperty1),
      expression: "accord24.InsurerLetter3_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter3_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter3_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherProperty1),
      expression: "accord24.InsurerLetter3_OtherProperty1"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter3_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsOtherProperty2),
      expression: "accord24.InsurerLetter3_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter3_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter3_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherProperty2),
      expression: "accord24.InsurerLetter3_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter3_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_IsOtherProperty3),
      expression: "accord24.InsurerLetter3_IsOtherProperty3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter3_IsOtherProperty3) ? _vm._i(_vm.accord24.InsurerLetter3_IsOtherProperty3, null) > -1 : (_vm.accord24.InsurerLetter3_IsOtherProperty3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter3_IsOtherProperty3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter3_IsOtherProperty3 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter3_IsOtherProperty3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter3_IsOtherProperty3", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter3_IsOtherProperty3)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherProperty3),
      expression: "accord24.InsurerLetter3_OtherProperty3"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherProperty3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherProperty3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherProperty3) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter3_OtherPropertyLimit3),
      expression: "accord24.InsurerLetter3_OtherPropertyLimit3"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter3_OtherPropertyLimit3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter3_OtherPropertyLimit3", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter3_OtherPropertyLimit3) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4),
      expression: "accord24.InsurerLetter4"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_IsBoiler),
      expression: "accord24.InsurerLetter4_IsBoiler"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter4_IsBoiler) ? _vm._i(_vm.accord24.InsurerLetter4_IsBoiler, null) > -1 : (_vm.accord24.InsurerLetter4_IsBoiler)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter4_IsBoiler,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter4_IsBoiler = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter4_IsBoiler = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter4_IsBoiler", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter4_IsBoiler)) + " ")]) : _vm._e(), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_PolicyNumber),
      expression: "accord24.InsurerLetter4_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_EffectiveDate),
      expression: "accord24.InsurerLetter4_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_ExpirationDate),
      expression: "accord24.InsurerLetter4_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_IsOtherProperty1),
      expression: "accord24.InsurerLetter4_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter4_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter4_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter4_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter4_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter4_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter4_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter4_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter4_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherProperty1),
      expression: "accord24.InsurerLetter4_OtherProperty1"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherProperty1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherProperty1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherProperty1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter4_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_IsOtherProperty2),
      expression: "accord24.InsurerLetter4_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter4_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter4_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter4_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter4_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter4_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter4_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter4_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter4_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherProperty2),
      expression: "accord24.InsurerLetter4_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter4_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter4_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter4_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter4_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter4_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5),
      expression: "accord24.InsurerLetter5"
    }],
    staticClass: "sm1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherInsurance1),
      expression: "accord24.InsurerLetter5_OtherInsurance1"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherInsurance1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherInsurance1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherInsurance1) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "4"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_PolicyNumber),
      expression: "accord24.InsurerLetter5_PolicyNumber"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_PolicyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_PolicyNumber", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_PolicyNumber) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_EffectiveDate),
      expression: "accord24.InsurerLetter5_EffectiveDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_EffectiveDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_EffectiveDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_EffectiveDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "textcenter",
    attrs: {
      "rowspan": "2",
      "colspan": "2"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_ExpirationDate),
      expression: "accord24.InsurerLetter5_ExpirationDate"
    }],
    staticClass: "lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_ExpirationDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_ExpirationDate", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_ExpirationDate) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_IsOtherProperty1),
      expression: "accord24.InsurerLetter5_IsOtherProperty1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter5_IsOtherProperty1) ? _vm._i(_vm.accord24.InsurerLetter5_IsOtherProperty1, null) > -1 : (_vm.accord24.InsurerLetter5_IsOtherProperty1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter5_IsOtherProperty1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter5_IsOtherProperty1 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter5_IsOtherProperty1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter5_IsOtherProperty1", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter5_IsOtherProperty1)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherProperty),
      expression: "accord24.InsurerLetter5_OtherProperty"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherProperty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherProperty", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherProperty) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n          $\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherPropertyLimit1),
      expression: "accord24.InsurerLetter5_OtherPropertyLimit1"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherPropertyLimit1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherPropertyLimit1", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherPropertyLimit1) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [(!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_IsOtherProperty2),
      expression: "accord24.InsurerLetter5_IsOtherProperty2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.accord24.InsurerLetter5_IsOtherProperty2) ? _vm._i(_vm.accord24.InsurerLetter5_IsOtherProperty2, null) > -1 : (_vm.accord24.InsurerLetter5_IsOtherProperty2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.accord24.InsurerLetter5_IsOtherProperty2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accord24.InsurerLetter5_IsOtherProperty2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.accord24.InsurerLetter5_IsOtherProperty2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accord24, "InsurerLetter5_IsOtherProperty2", $$c)
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "span-checkbox"
  }, [_vm._v(" " + _vm._s(_vm.translateCheckbox(_vm.accord24.InsurerLetter5_IsOtherProperty2)) + " ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherProperty2),
      expression: "accord24.InsurerLetter5_OtherProperty2"
    }],
    staticClass: "txt1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherProperty2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherProperty2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherProperty2) + " ")]) : _vm._e()]), _c('td', [_vm._v("\n            $\n            "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.InsurerLetter5_OtherPropertyLimit2),
      expression: "accord24.InsurerLetter5_OtherPropertyLimit2"
    }],
    staticClass: "txt",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.InsurerLetter5_OtherPropertyLimit2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "InsurerLetter5_OtherPropertyLimit2", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.InsurerLetter5_OtherPropertyLimit2) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3",
      "colspan": "20"
    }
  }, [_vm._v("\n          SPECIAL CONDITIONS/OTER CVERAGES (Use Additional Remarks, if more space is required)\n          "), (!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.SpecialConditions),
      expression: "accord24.SpecialConditions"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.SpecialConditions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "SpecialConditions", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.SpecialConditions))
    }
  }) : _vm._e()])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "rowspan": "5",
      "colspan": "10"
    }
  }, [(!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.CertificateHolder),
      expression: "accord24.CertificateHolder"
    }],
    staticClass: "lg-textarea",
    attrs: {
      "disabled": !_vm.readonly && !_vm.requestViewer,
      "placeholder": "Certificate Holder will be filled at time of request",
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.CertificateHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "CertificateHolder", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "100px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.CertificateHolder))
    }
  }) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "content6",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "rowspan": "3",
      "colspan": "10"
    }
  }, [_vm._v("\n          SHOULD ANY OF THE ABOVE DESCRIBED POLICIES BE CANCELLED BEFORE\n          "), _c('BR'), _vm._v(" THE EXPIRATION DATE THEREOF, NOTICE WILL BE DELIVERED IN\n          "), _c('BR'), _vm._v(" ACCORDANCE WITH THE POLICY PROVISIONS.\n        ")], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2",
      "colspan": "10"
    }
  }, [_vm._v("\n          AUTHORIZED REPRESENTATIVE\n          "), (!_vm.readonly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.AuthorizedRepresentative),
      expression: "accord24.AuthorizedRepresentative"
    }],
    staticClass: "md-textarea",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.AuthorizedRepresentative)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "AuthorizedRepresentative", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "pdf-input"
  }, [_vm._v(" " + _vm._s(_vm.accord24.AuthorizedRepresentative) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('h1', {
    staticClass: "title additional-remarks-header"
  }, [_vm._v("ADDITIONAL REMARKS")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "rowspan": "5",
      "colspan": "10"
    }
  }, [(!_vm.readonly) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accord24.AdditionalRemarks),
      expression: "accord24.AdditionalRemarks"
    }],
    staticClass: "remarks-textarea",
    attrs: {
      "placeholder": "Use this section for additional remarks related to the policy and coverage",
      "type": "text"
    },
    domProps: {
      "value": (_vm.accord24.AdditionalRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.accord24, "AdditionalRemarks", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('div', {
    staticClass: "pdf-input",
    staticStyle: {
      "min-height": "1225px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.translateTextarea(_vm.accord24.AdditionalRemarks))
    }
  }) : _vm._e()])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n          DATE (MM/DD/YYYY)\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "content1",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("\n          THIS CERTIFICATE IS ISSUED AS A MATTER OF INFOMATION ONLY AND CONFERS NO RIGHTS UPON THE CERTIFICATE HOLDER. THIS CERTIFICATE\n          DOES NOT AFFIRMATIVELY OR NEGATIVELY AMEND, EXTEND OR ALTER THE COVERAGE AFFORDED BY THE POLICIES BELOW. THIS\n          CERTIFICATE OF INSURANCE DOES NOT CONSTITUTE A CONSTRACT VETWEEN THE ISSUING INSURER(S), AUTHORIZED REPRESENTATIVE\n          OR PRODUCER, AND THE CERTIFICATE HOLDER.\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("\n            INSURER(S) AFFORDING COVERAGE\n          ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("\n            NAIC#\n          ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "content4",
    attrs: {
      "colspan": "20"
    }
  }, [_vm._v("\n          THIS IS TO CERTFY THAT TIE POLICIES OF INSURANCE LISTED BELOW HAVE BEEN ISSUED TO THE INSURED NAMED ABOVE FOR THE POLICY\n          PERIOD INDICATED. NOTWITHSTANDING ANY REQUIREMENT, TERM OF CONDITION OF ANY CONTRACT OR OTHER DOCUMENT WITH RESPECT\n          TO WHICH THIS CERTIFICATE MAY BE ISSUSED OR MAY PERTAIN, THE INSURANCE AFFORDED BY THE POLICIES DESCRIBED HEREIN\n          IS SUBJECT TO ALL THE TERMS, EXCLUSIONS AND CONDITIONS OF SUCH POLICIES. LIMITS SHOWN MAY HAVE BEEN REDUCED BY\n          PAID CLAIMS.\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "content5"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          INSR\n          "), _c('br'), _vm._v("LTR\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          TYPE OF INSURANCE\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n          POLICY NUMBER\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          POLICY EFFECTIVE\n          "), _c('br'), _vm._v("DATE(MM/DD/YYYY)\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n          POLICYEXPIRATION\n          "), _c('br'), _vm._v("DATE(MM/DD/YYYY)\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          COVERED PROPERTY\n        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n          LIMITS\n        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro"
  }, [_vm._v("PROPERTY")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro"
  }, [_vm._v(" INLAND MARINE")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro",
    staticStyle: {
      "line-height": "31px"
    }
  }, [_vm._v(" CRIME\n            ")]), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('label', {
    staticClass: "pro"
  }, [_vm._v(" BOILER & MACHINERY /\n              "), _c('br'), _vm._v(" EQUIPMENT BREAKDOWN\n            ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "id": "middle_part2"
    }
  }, [_c('tr', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("\n          CERTIFICATE HOLDER\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("\n          CANCELLATION\n        ")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+wH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+zJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var accordUtil = {
  getAccordDOM: function getAccordDOM(accordForm) {
    var prefix = '<html>\n                            <head>\n                              <title>Certificate of Property Insurance</title>\n                              <style type = "text/css">\n                                    body {\n                                      font-family: Arial,Helvetica Neue,Helvetica,sans-serif; \n                                  }\n                                  table {\n                                    border-collapse: collapse;\n                                  }\n    \n                                  table,\n                                  td,\n                                  th {\n                                    border: 1px solid black;\n                                    padding: 0px;\n                                    font-size: 9px;\n                                    margin: 3px 0px 3px 0px;\n                                  }\n    \n                                  tr td .pro {\n                                    vertical-align: middle;\n                                    display: table-cell;\n                                    padding-left: 3px;\n                                    line-height: 24px;\n                                  }\n    \n                                  tr td .con {\n                                    float: left;\n                                    padding-left: 3px;\n                                    line-height: 20px;\n                                  }\n    \n                                  tr td .spn {\n                                    margin-left: 3px;\n                                  }\n    \n                                  td {\n                                    padding-left: 4px;\n                                    padding-right: 4px;\n                                  }\n    \n                                  hr {\n                                    border: 0;\n                                    height: 1px;\n                                    background: #000000;\n                                  }\n    \n                                  .rmbottom {\n                                    border-bottom: none;\n                                  }\n    \n                                  .rmtop {\n                                    border-top: none;\n                                  }\n    \n                                  .rmbt {\n                                    border-bottom: none;\n                                    border-top: none;\n                                  }\n    \n                                  .sm {\n                                    height: 10px;\n                                    width: 80%;\n                                  }\n    \n                                  .sm1 {\n                                    height: 20px;\n                                    width: 20px;\n                                  }\n    \n                                  .lg {\n                                    height: 20px;\n                                    width: 100%;\n                                  }\n    \n                                  .lg-textarea {\n                                    height: 90px;\n                                    width: 100%;\n                                    resize: none;\n                                  }\n    \n                                  .md-textarea {\n                                    height: 40px;\n                                    width: 100%;\n                                    resize: none;\n                                  }\n    \n                                  .lg-80 {\n                                    height: 20px;\n                                    width: 80%;\n                                    margin-left: 20px;\n                                  }\n    \n                                  .lg-70 {\n                                    height: 20px;\n                                    width: 70%;\n                                  }\n    \n                                  .lg-60 {\n                                    height: 20px;\n                                    width: 60%;\n                                  }\n    \n                                  .lg-40 {\n                                    height: 20px;\n                                    width: 40%;\n                                  }\n    \n                                  .lg-30 {\n                                    height: 20px;\n                                    width: 30%;\n                                  }\n    \n                                  tr td .txt {\n                                    width: 60px;\n                                    height: 20px;\n                                    padding-left: 3px;\n                                  }\n    \n                                  tr td .txt1 {\n                                    width: 100px;\n                                    height: 20px;\n                                    padding-left: 3px;\n                                  }\n    \n                                  div .daytag {\n                                    border: 1px solid;\n                                    width: 15%;\n                                    text-align: center;\n                                    border-bottom: none;\n                                    font-size: 8px;\n                                    margin-top: -30px;\n                                    clear: both;\n                                    float: right;\n                                    margin-right: 3px;\n                                  }\n    \n                                  .title {\n                                    text-align: center;\n                                    font-size: 22px;\n                                    font-weight: bold;\n                                  }\n    \n                                  th {\n                                    text-align: center;\n                                  }\n    \n                                  textarea {\n                                    background-color: #eff0ff;\n                                    border: none;\n                                    padding: 5px 5px 5px 5px;\n                                    font-weight: 500;\n                                  }\n    \n                                  input {\n                                    border: none;\n                                    border-color: transparent;\n                                    font-size: 10px;\n                                    background-color: #eff0ff;\n                                    font-weight: 500;\n                                  }\n    \n                                  input[type="checkbox"] {\n                                    -webkit-appearance: initial;\n                                    appearance: initial;\n                                    background: #D1D1D1;\n                                    width: 20px;\n                                    height: 20px;\n                                    border: none;\n                                    background: #CECCCC;\n                                    position: relative;\n                                    float: left;\n                                    margin: 0px 0px 0px 0px;\n                                    background-color: #eff0ff;\n                                  }\n    \n                                  input[type="checkbox"]:checked {\n                                    background: #FFFCFC;\n                                    margin: 0px 0px 0px 0px;\n                                  }\n    \n                                  input[type="checkbox"]:checked:after {\n                                    content: "\\2715";\n                                    color: #000000;\n                                    position: absolute;\n                                    left: 50%;\n                                    top: 50%;\n                                    -webkit-transform: translate(-50%, -50%);\n                                    -moz-transform: translate(-50%, -50%);\n                                    -ms-transform: translate(-50%, -50%);\n                                    transform: translate(-50%, -50%);\n                                    margin: 0px 0px 0px 0px;\n                                  }\n    \n                                  div {\n                                    font-size: 9px;\n                                    font-weight: normal;\n                                    margin: 0px 0px 0px 0px;\n                                    padding: 0px 0px 0px 0px;\n                                  }\n    \n                                  .content1 {\n                                    font-size: 11px;\n                                    font-weight: bold;\n                                    padding-left: 20px;\n                                  }\n    \n                                  .content2 {\n                                    margin-top: -18px;\n                                  }\n    \n                                  .content3 {\n                                    font-size: 9px;\n                                    font-weight: bold;\n                                  }\n    \n                                  .content4 {\n                                    font-size: 11px;\n                                    padding-left: 15px;\n                                  }\n    \n                                  .content5 {\n                                    font-size: 9px;\n                                    font-weight: bold;\n                                  }\n    \n                                  .content6 {\n                                    padding: 5px 10px 10px 5px;\n                                  }\n    \n                                  #middle_part td {\n                                    font-weight: bold;\n                                    border: none !important;\n                                    font-size: 12px;\n                                  }\n    \n                                  #middle_part2 td {\n                                    font-weight: bold;\n                                    border: none !important;\n                                    font-size: 12px;\n                                  }\n    \n                                  .textcenter {\n                                    text-align: center;\n                                  }\n    \n                                  #piece {\n                                    position: absolute;\n                                    float: right;\n                                    top: 5px;\n                                    right: 0px;\n                                    text-align: center;\n                                  }\n    \n                                  .span-checkbox {\n                                    height: 15px;\n                                    width: 15px;\n                                    padding-top: 3px;\n                                    float: left;\n                                    text-align: center;\n                                  }\n    \n                                  .additional-remarks-header {\n                                    padding-top: 100px;\n                                  }\n    \n                                  .remarks-textarea {\n                                    min-height: 800px;\n                                    width: 100%;\n                                    resize: none;\n                                  }\n    \n                                  .pdf-input {\n                                    font-weight: 700;\n                                    font-size: 11.5px;\n                                  }\n                              </style>\n                            </head>\n                            <body>\n            ';
    return prefix + accordForm + '</body></html>';
  }
};

/* harmony default export */ __webpack_exports__["a"] = (accordUtil);

/***/ }),

/***/ "/WL8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-page-header"
  }, [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/requests"
    }
  }, [_vm._v("Requests")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v(_vm._s(_vm.request.Association.Name))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "field crud-buttons is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control hide-mobile"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        _vm.putRequest(_vm.request)
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_vm._v("\n            Email (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-envelope-open",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-envelope-open"
  })])]), _vm._v(" "), _c('span', [_c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_vm._v("\n            Download (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-download"
  })])])]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-body"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Requester Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.RequesterName),
      expression: "request.RequesterName"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Requester Name"
    },
    domProps: {
      "value": (_vm.request.RequesterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "RequesterName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Requester Email")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.RequesterEmail),
      expression: "request.RequesterEmail"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Requester Email"
    },
    domProps: {
      "value": (_vm.request.RequesterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "RequesterEmail", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-desktop"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Accord24', {
    attrs: {
      "accord24": _vm.accord24,
      "requestViewer": true
    }
  }), _vm._v(" "), _c('Accord24', {
    ref: "accord",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accord24": _vm.accord24,
      "readonly": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.request.Association.Attachments && _vm.request.Association.Attachments.length > 0) ? _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "20px",
      "max-width": "330px",
      "word-break": "break-all"
    }
  }, [_c('h4', [_vm._v("Additional Declarations")]), _vm._v(" "), _c('ul', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px",
      "margin-bottom": "0px"
    }
  }, _vm._l((_vm.request.Association.Attachments), function(attachment) {
    return _c('li', [_c('a', {
      attrs: {
        "href": attachment.downloadURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.fileName))])])
  }))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showEmailModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Email Certificate")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  })]), _vm._v(" "), (!_vm.emailSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.to),
      expression: "emailData.to"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "to", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidTo) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CC")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.cc),
      expression: "emailData.cc"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.cc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "cc", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidCc) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.getAttachmentName()))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.message),
      expression: "emailData.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter message"
    },
    domProps: {
      "value": (_vm.emailData.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.emailError) ? _c('section', {
    staticClass: "modal-card-body"
  }, [_c('hr'), _vm._v(" Error sending email! Please try again or download PDF and send externally.\n          "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    class: {
      'is-loading': _vm.isSendingEmail
    },
    on: {
      "click": function($event) {
        _vm.sendEmailMessage(_vm.emailData)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.emailSuccess) ? _c('div', [_vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section hide-mobile"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Request Information")]), _vm._v(" "), _c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you, your email has been sent.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/oTH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0mr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-page-header"
  }, [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Associations")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v(_vm._s(_vm.association.Name))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "field crud-buttons is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control hide-mobile"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [(_vm.isNewAssociation) ? _c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.postAssociation(_vm.association)
      }
    }
  }, [_vm._v("Create")]) : _vm._e(), _vm._v(" "), (!_vm.isNewAssociation) ? _c('button', {
    staticClass: "button is-link",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        _vm.putAssociation(_vm.association)
      }
    }
  }, [_vm._v("Save")]) : _vm._e()]), _vm._v(" "), (!_vm.isNewAssociation) ? _c('div', {
    staticClass: "control"
  }, [_c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_vm._v("\n            Preview\n            "), _c('i', {
    staticClass: "fa fa-lg fa-file-pdf-o",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-file-pdf-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.isNewAssociation) ? _c('div', {
    staticClass: "control"
  }, [_c('el-popover', {
    ref: "popover5",
    attrs: {
      "placement": "bottom",
      "width": "500",
      "title": "Certificate Request Link"
    },
    model: {
      value: (_vm.showLinkPopover),
      callback: function($$v) {
        _vm.showLinkPopover = $$v
      },
      expression: "showLinkPopover"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.link))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover5",
      arg: "popover5"
    }],
    staticClass: "button is-link"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-link"
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isNewAssociation) ? _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link hide-mobile",
    on: {
      "click": function($event) {
        _vm.postRequest(_vm.association)
      }
    }
  }, [_vm._v("\n            Copy to Request\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    on: {
      "click": function($event) {
        _vm.postRequest(_vm.association)
      }
    }
  }, [_vm._v("\n            Copy\n          ")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-body"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.association.Name),
      expression: "association.Name"
    }],
    staticClass: "input is-small",
    class: {
      'is-required': _vm.missingName
    },
    attrs: {
      "type": "text",
      "placeholder": "Homeowners Association Name"
    },
    domProps: {
      "value": (_vm.association.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.association, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.missingName) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Please set Association Name\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Access Pin Number\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.association.PinNumber),
      expression: "association.PinNumber"
    }],
    staticClass: "input is-small",
    class: {
      'is-required': _vm.invalidPinNumber
    },
    attrs: {
      "type": "text",
      "placeholder": "Pin Number"
    },
    domProps: {
      "value": (_vm.association.PinNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.association, "PinNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.missingPinNumber) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Please set Pin Number\n            ")]) : _vm._e(), _vm._v(" "), (_vm.duplicatePinNumber) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Pin Number already used, please use a different number\n            ")]) : _vm._e(), _vm._v(" "), (_vm.shortPinNumber) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n              Pin Number must be at least 5 characters\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Status\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.association.Status),
      expression: "association.Status"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.association, "Status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("Draft - Not Published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active - Published")])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-variable is-5 is-desktop",
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Accord24', {
    attrs: {
      "accord24": _vm.association.Accord24
    }
  }), _vm._v(" "), _c('Accord24', {
    ref: "accord",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accord24": _vm.association.Accord24,
      "readonly": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "multiple": "",
      "id": "uploadInput",
      "type": "file"
    },
    on: {
      "change": _vm.handleFileSelected
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    class: {
      'is-loading': _vm.isAttaching
    },
    on: {
      "click": _vm.attach
    }
  }, [_vm._v("Additional\n            Declarations\n            "), _c('i', {
    staticClass: "fa fa-paperclip",
    staticStyle: {
      "margin-left": "10px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "5px"
    }
  }, _vm._l((_vm.association.Attachments), function(attachment) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": attachment.downloadURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.fileName))])]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times",
      staticStyle: {
        "margin-left": "8px",
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.deleteAttachment(attachment)
        }
      }
    })])])
  }))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showCopyToRequestModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Copy to Request")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showCopyToRequestModal = false
      }
    }
  })]), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Owner Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.PropertyOwnerName),
      expression: "request.PropertyOwnerName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Owner Full Name"
    },
    domProps: {
      "value": (_vm.request.PropertyOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "PropertyOwnerName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.PropertyAddress),
      expression: "request.PropertyAddress"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Address"
    },
    domProps: {
      "value": (_vm.request.PropertyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "PropertyAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Loan Number")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.LoanNumber),
      expression: "request.LoanNumber"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Loan Number"
    },
    domProps: {
      "value": (_vm.request.LoanNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "LoanNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Certificate Holder")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.CertificateHolder),
      expression: "request.CertificateHolder"
    }],
    staticClass: "textarea",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Lender Certificiate Holder Information"
    },
    domProps: {
      "value": (_vm.request.CertificateHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "CertificateHolder", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.postRequest(this.association)
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showCopyToRequestModal = false
      }
    }
  }, [_vm._v("Cancel")])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section hide-mobile"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Association Information")]), _vm._v(" "), _c('hr')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0sG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1KpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      Finalize Request\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.RequesterName),
      expression: "Request.RequesterName"
    }],
    staticClass: "input",
    class: {
      'is-required': _vm.missingName
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Your Name"
    },
    domProps: {
      "value": (_vm.Request.RequesterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "RequesterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Your Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.RequesterEmail),
      expression: "Request.RequesterEmail"
    }],
    staticClass: "input",
    class: {
      'is-required': _vm.missingEmail
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Your Email Address"
    },
    domProps: {
      "value": (_vm.Request.RequesterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "RequesterEmail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.Association.Name),
      expression: "Request.Association.Name"
    }],
    staticClass: "input",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Request.Association.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request.Association, "Name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [(!_vm.missingName && !_vm.missingEmail) ? _c('i', {
    staticClass: "fa fa-check fa-4x"
  }) : _vm._e(), _vm._v(" "), (!_vm.missingName && !_vm.missingEmail) ? _c('p', [_vm._v("Click Finalize to complete your request.")]) : _vm._e(), _vm._v(" "), (_vm.missingName || _vm.missingEmail) ? _c('p', [_vm._v("Please complete name and email address.")]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.submitted) ? _c('div', {
    staticClass: "has-text-centered opaque ",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x "
  }), _vm._v(" "), _c('p', [_vm._v("Finalizing Request...")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link is-outlined",
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("Finalize")])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1XP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "navContainer"
    }
  }, [_c('nav', {
    staticClass: "navbar is-light"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/GetCoi-Logo.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "navbar-burger burger",
    attrs: {
      "data-target": "navbarExampleTransparentExample"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleActive('navEllipsisMobile')
      }
    }
  }, [(_vm.user.email) ? _c('div', {
    ref: "navEllipsisMobile",
    staticClass: "dropdown",
    staticStyle: {
      "margin-top": "12px",
      "margin-left": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "dropdown-menu3",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                      Logout\n                    ")])])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    attrs: {
      "id": "navMenuTransparentExample"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("Getting Started")]), _vm._v(" "), (_vm.user.email) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Associations")]) : _vm._e(), _vm._v(" "), (_vm.user.email) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/requests"
    }
  }, [_vm._v("Requests")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [(_vm.user.email) ? [_c('span', {
    attrs: {
      "id": "email"
    }
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('div', {
    ref: "navEllipsis",
    staticClass: "dropdown",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "icon is-small fa-button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleActive('navEllipsis')
      }
    }
  }, [_c('i', {
    staticClass: " fa fa-ellipsis-h"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "id": "dropdown-menu3",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                          Logout\n                        ")])])])])] : _vm._e()], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "52px",
      "padding-bottom": "50px"
    }
  }, [_c('router-view')], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('div', {
    staticClass: "icon is-small fa-button"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h"
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2kZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssociationsList',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      showCopyModal: false,
      copyIndex: null,
      copyData: {
        newAssociationName: ''
      },
      deleteIndex: null,
      deleteText: '',
      disableDeleteContinue: true,
      openDropdownRef: {},
      associations: []
    };
  },
  methods: {
    initialize: function initialize() {
      var _this = this;

      window.document.title = 'Associations';
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations').once('value').then(function (snapshot) {
        _this.associations = __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].getArray(snapshot.val());
        _this.isLoading = false;
      });
    },
    toggleActive: function toggleActive(ref) {
      if (this.openDropdownRef.classList) {
        this.away();
        return;
      }
      if (this.$refs[ref]) {
        this.openDropdownRef = this.$refs[ref][0];
        this.openDropdownRef.classList.add('is-active');
      }
    },
    openCopyModal: function openCopyModal(index) {
      this.copyIndex = index;
      this.copyData.newAssociationName = '';
      this.showCopyModal = true;
    },
    copyAssociation: function copyAssociation(index, newAssociationName) {
      if (newAssociationName) {
        var newAssoc = this.associations[index];
        newAssoc.Name = newAssociationName;
        newAssoc.Status = 'draft';
        newAssoc.PinNumber = null;
        var response = __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations').push(newAssoc);
        // this.setReferenceData(response.key, newAssoc)
        this.$router.push('/associations/' + response.key);
      }
    },
    openDeleteModal: function openDeleteModal(index) {
      this.deleteIndex = index;
      this.showDeleteModal = true;
    },
    checkDeleteText: function checkDeleteText(text) {
      if (text === 'DELETE') {
        this.disableDeleteContinue = false;
      } else {
        this.disableDeleteContinue = true;
      }
    },
    deleteAssociation: function deleteAssociation(index) {
      var _this2 = this;

      var key = this.associations[index].key;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations/' + key).remove().then(function () {
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].name + '/associations/' + key).remove();
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('pins/' + key).remove();
        _this2.deleteIndex = index;
        _this2.showDeleteModal = false;
        _this2.deleteText = '';
        _this2.disableDeleteContinue = true;
        _this2.initialize();
      });
    },
    setReferenceData: function setReferenceData(key, association) {
      if (association.Status !== 'draft') {
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].name + '/associations/' + key).set(association.Name);
      }

      if (association.Status === 'draft') {
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].name + '/associations/' + key).remove();
      }

      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('pins/' + key).set(association.PinNumber);
    },
    away: function away() {
      if (this.openDropdownRef.classList) {
        this.openDropdownRef.classList.remove('is-active');
        this.openDropdownRef = {};
      }
    },
    getStatus: function getStatus(status) {
      if (status === 'draft') {
        return '<span class="tag is-light">Draft</span>';
      }
      if (status === 'active') {
        return '<span class="tag is-info">Active</span>';
      }
      return null;
    }
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].initialize().then(function () {
      _this3.initialize(_this3.$route);
    });
  }
});

/***/ }),

/***/ "4N5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter content"
  }, [_c('h5', [_vm._v("COI Solutions, " + _vm._s(_vm.getYear()))]), _vm._v(" "), _c('div', [_c('p', [_vm._v("We help independent insurance brokers automate certificate of insurance requests.")]), _vm._v(" "), _c('a', {
    staticClass: " is-small",
    on: {
      "click": function($event) {
        _vm.showContactForm = true
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Contact Us")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showContactForm
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  })]), _vm._v(" "), (!_vm.contactSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter your message, we'll respond as quickly as possible"
    },
    domProps: {
      "value": (_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.sendContactMessage(_vm.contact)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.contactSuccess) ? _c('div', [_vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you for contacting us. We will return your message as soon as possible.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4b0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title is-4"
  }, [_vm._v("Managing Associations and Certificates")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p'), _c('h4', {
    staticClass: "title is-5"
  }, [_vm._v("Associations")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("The first step in streamlining evidence of insurance requests is to create Associations. To create an Association,\n        choose the\n        "), _c('em', [_vm._v("Create Association")]), _vm._v(" button from the\n        "), _c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Associations")]), _vm._v(" page.\n        "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._m(6), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p'), _c('h4', {
    staticClass: "title is-5"
  }, [_vm._v("Direct Link Requests")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10), _vm._m(11), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n          Please click the Contact Us link below if you have any questions or need help.\n        ")])])]), _vm._v(" "), _c('Footer')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "max-width": "900px",
      "min-height": "210px"
    },
    attrs: {
      "src": "/static/img/CreateAssociation.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Manage Associations List")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This will open the Association detail page. On this page you set the Association Name, Pin Number and Status. The\n        "), _c('em', [_vm._v("Pin Number")]), _vm._v(" is used to create a unique URL link for the certificate. See the section below on Direct Link Requests\n        for more information about links to certificates.\n      ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        When the Association\n        "), _c('em', [_vm._v("Status")]), _vm._v(" is set to Draft, the certificate will not be linkable, so make sure to set the Status to Active when\n        you are ready to enable users to access the certificate. Once you have entered the Association Name and Pin Number,\n        you can click the\n        "), _c('em', [_vm._v("Create")]), _vm._v(" button to save the association.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Now, along the top of the Association page, you will see several buttons. Click the\n        "), _c('em', [_vm._v("Preview")]), _vm._v(" button to generate and download a preview PDF file of the Certificate. Use the\n        "), _c('em', [_vm._v("Link")]), _vm._v(" icon button to get a link to the certificate. This is the link you can send to owners, loan processors\n        and property managers who need to access and generate certificates. Use the\n        "), _c('em', [_vm._v("Copy to Request")]), _vm._v(" button to copy the certificate into a request which you can then customize for a specific\n        person, e.g., by customizing the Certificate Holder.\n        "), _c('br'), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "min-height": "175px"
    },
    attrs: {
      "src": "/static/img/AssociationDetailsHeader.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Association Header Fields")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The main section on the Associations page is the Certificate itself. This is a comprehensive form where you can enter details\n          about the insurance policies, expiration dates and coverage that the Association carries. Use the Additional\n          Remarks addendum to provide extra details. You may want to anticipate common questions that a bank normally has\n          and preemptively provide that information. Once you have completed this form, you can set the\n          "), _c('em', [_vm._v("Status")]), _vm._v(" to Active and click the\n          "), _c('em', [_vm._v("Link")]), _vm._v(" button to get the direct link to the certificate. You can paste the link into your browser and try\n          it yourself. When a user requests the Certificate, this form will be generated as a PDF file. Here is an\n          "), _c('a', {
    attrs: {
      "href": "/static/InsuranceCertificate.pdf",
      "target": "_blank"
    }
  }, [_vm._v("example PDF Certificate")]), _vm._v(".\n          "), _c('br'), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/CertificateForm.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Association Certificate Form")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Now that you have created one of more Associations and their evidence of insurance certificates, users can request copies\n          of those certificates via direct links. Direct links take the form of\n          "), _c('em', [_vm._v("https://www.getcoi.com/certificates/<your agency short name>/<association PIN number>")]), _vm._v(". For an example,\n          try\n          "), _c('a', {
    attrs: {
      "href": "/certificates/arrowig/11111"
    }
  }, [_vm._v("https://www.getcoi.com/certificates/arrowig/11111")]), _vm._v(".\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          When users navigate to a direct link in a web browser, a small request form will be shown. Users can enter 4 pieces of data\n          into this form, which will be populated into the certificate PDF. The\n          "), _c('em', [_vm._v("Property Owner Full Name, Property Address and Loan Number")]), _vm._v(" will be populated into the Additional Remarks\n          addendum of the certificate and the\n          "), _c('em', [_vm._v("Certificate Holder")]), _vm._v(" will be populated into the Certificate Holder field of the certificate. After hitting\n          next, users will be prompted to enter their name and email address, after which, their certificate will be generated\n          and they can download the PDF file.\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "src": "/static/img/RequestForm.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Certificate Request Form")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Certificate requests are recorded by the system and can be viewed, modified and regenerated on the\n          "), _c('a', {
    attrs: {
      "href": "/requests"
    }
  }, [_vm._v("Requests")]), _vm._v(" page.\n          "), _c('br'), _vm._v(" "), _c('br')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/Requests.jpg"
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "caption"
  }, [_vm._v("Requests List")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4jZn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5eNK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5tXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__ = __webpack_require__("8Fst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c7d280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__ = __webpack_require__("JDfm");
function injectStyle (ssrContext) {
  __webpack_require__("WHG4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61c7d280"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c7d280_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Rv6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FinalizeRequest',
  props: ['Request'],
  data: function data() {
    return {
      submitted: false,
      missingName: false,
      missingEmail: false,
      found: false
    };
  },
  methods: {
    next: function next() {
      if (!this.Request.RequesterEmail || !this.Request.RequesterName) {
        if (!this.Request.RequesterEmail) {
          this.missingEmail = true;
        } else {
          this.missingEmail = false;
        }

        if (!this.Request.RequesterName) {
          this.missingName = true;
        } else {
          this.missingName = false;
        }
      } else {
        this.submitted = true;
        this.found = false;
        this.$emit('finalize');
      }
    },
    previous: function previous() {
      this.$emit('previous');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "8Fst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AssociationPin__ = __webpack_require__("Yai7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropertyInformation__ = __webpack_require__("MP1z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FinalizeRequest__ = __webpack_require__("f63L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RequestComplete__ = __webpack_require__("jPax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer__ = __webpack_require__("ODK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tenant__ = __webpack_require__("Swjk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Request',
  data: function data() {
    return {
      loading: true,
      submitted: false,
      showNotFound: false,
      found: false,
      hasTenant: false,
      stage: 1,
      tenantName: '',
      tenantLongName: null,
      tenantPhoneNumber: null,
      agencies: [],
      Request: {
        PinNumber: '',
        PropertyOwnerName: '',
        PropertyAddress: '',
        LoanNumber: '',
        CertificateHolder: '',
        RequesterEmail: '',
        RequesterName: '',
        Date: ''
      }
    };
  },
  methods: {
    next: function next() {
      this.stage++;
    },
    previous: function previous() {
      this.stage--;
    },
    finalize: function finalize() {
      this.Request.Association.Accord24.CertificateHolder = this.Request.CertificateHolder;
      this.Request.Association.Accord24.AdditionalRemarks = this.Request.Association.Accord24.AdditionalRemarks || '';
      if (this.Request.PropertyOwnerName) {
        this.Request.Association.Accord24.AdditionalRemarks += '<br><br>PROPERTY OWNER NAME:  ' + this.Request.PropertyOwnerName;
      }
      if (this.Request.PropertyAddress) {
        this.Request.Association.Accord24.AdditionalRemarks += '<br><br>PROPERTY ADDRESS:  ' + this.Request.PropertyAddress;
      }
      if (this.Request.LoanNumber) {
        this.Request.Association.Accord24.AdditionalRemarks += '<br><br>LOAN NUMBER:  ' + this.Request.LoanNumber;
      }
      this.postRequest();
      this.stage++;
    },
    cancel: function cancel() {
      this.$router.push('/');
    },
    tenantSelected: function tenantSelected(tenantName) {
      var _this = this;

      this.tenantName = tenantName;
      __WEBPACK_IMPORTED_MODULE_6__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + tenantName).once('value').then(function (snapshot) {
        _this.tenantLongName = snapshot.val().name;
        _this.tenantPhoneNumber = snapshot.val().phone;
      });
    },
    getAssociation: function getAssociation() {
      var _this2 = this;

      this.showNotFound = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("" + '/api/' + this.tenantName + '/certificates?PinNumber=' + this.Request.PinNumber).then(function (response) {
        _this2.Request.Association = response.data;
        _this2.next();
        _this2.loading = false;
      }).catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            _this2.showNotFound = true;
          }
        }
        console.log(error);
      });
    },
    postRequest: function postRequest() {
      var _this3 = this;

      this.Request.Date = new Date().toISOString();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("" + '/api/' + this.tenantName + '/requests', this.Request).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            _this3.showNotFound = true;
          }
        }
        console.log(error);
      });
    },
    setTenantDetails: function setTenantDetails(tenantVal) {
      if (tenantVal) {
        this.tenantLongName = tenantVal.name;
        this.tenantPhoneNumber = tenantVal.phone;
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.tenantName = this.$route.params.tenantName;
    this.Request.PinNumber = this.$route.params.pinNumber;

    if (this.tenantName && this.Request.PinNumber) {
      __WEBPACK_IMPORTED_MODULE_6__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + this.tenantName).once('value').then(function (snapshot) {
        _this4.setTenantDetails(snapshot.val());
        _this4.getAssociation();
        _this4.hasTenant = true;
      });
    } else if (this.tenantName && !this.Request.PinNumber) {
      __WEBPACK_IMPORTED_MODULE_6__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + this.tenantName).once('value').then(function (snapshot) {
        _this4.setTenantDetails(snapshot.val());
        _this4.hasTenant = true;
        _this4.loading = false;
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_6__tenant__["a" /* default */].firebaseDb.ref('lists/agencies').once('value').then(function (snapshot) {
        _this4.agencies = snapshot.val();
        _this4.loading = false;
      });
    }
  },
  components: {
    AssociationPin: __WEBPACK_IMPORTED_MODULE_1__AssociationPin__["a" /* default */],
    PropertyInformation: __WEBPACK_IMPORTED_MODULE_2__PropertyInformation__["a" /* default */],
    FinalizeRequest: __WEBPACK_IMPORTED_MODULE_3__FinalizeRequest__["a" /* default */],
    RequestComplete: __WEBPACK_IMPORTED_MODULE_4__RequestComplete__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_5__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "8IRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicRequest_vue__ = __webpack_require__("X7+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d1c9597_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PublicRequest_vue__ = __webpack_require__("XQW4");
function injectStyle (ssrContext) {
  __webpack_require__("w/5r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d1c9597"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d1c9597_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PublicRequest_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9xQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Status'
});

/***/ }),

/***/ "Bi9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__ = __webpack_require__("9xQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b9ad91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__ = __webpack_require__("t5b5");
function injectStyle (ssrContext) {
  __webpack_require__("/oTH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51b9ad91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b9ad91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cbbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__("ODK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tenant__ = __webpack_require__("Swjk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Register',
  data: function data() {
    return {
      user: {
        name: '',
        email: '',
        password: '',
        passwordConfirm: ''
      },
      message: null,
      emailMessage: null
    };
  },
  methods: {
    register: function register(user) {
      var _this = this;

      if (this.validatePasswords(user)) {
        if (user.password === user.passwordConfirm) {
          __WEBPACK_IMPORTED_MODULE_1__tenant__["a" /* default */].app.auth().createUserWithEmailAndPassword(user.email, user.password).then(function () {
            _this.$router.push('/welcome');
          }).catch(function (error) {
            if (error) {
              if (error.message.toUpperCase().indexOf('EMAIL') > -1) {
                _this.emailMessage = error.message;
              } else {
                _this.message = error.message;
              }
            }
            console.log(error);
          });
        }
      }
    },
    validatePasswords: function validatePasswords(user) {
      this.message = null;
      this.emailMessage = null;

      if (!user.password || !user.passwordConfirm) {
        this.message = 'Please enter and confirm passwords';
        return false;
      }
      if (user.password !== user.passwordConfirm) {
        this.message = 'Passwords do not match';
        return false;
      }

      return true;
    }
  },
  created: function created() {
    console.log(this.$route);
    var name = this.$route.query['name'];
    var email = this.$route.query['email'];

    if (name) {
      this.user.name = name;
    }
    if (email) {
      this.user.email = email;
    }
  },
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "DQXn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accord24_vue__ = __webpack_require__("fe4I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0884f160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Accord24_vue__ = __webpack_require__("+0L8");
function injectStyle (ssrContext) {
  __webpack_require__("FGuh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0884f160"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accord24_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0884f160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Accord24_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DWyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGuh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FJN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("XbJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04971b5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("rA7G");
function injectStyle (ssrContext) {
  __webpack_require__("+wH4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04971b5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04971b5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__("ODK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      tenantName: '',
      showContactForm: false,
      contactSuccess: false,
      contact: {
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__tenant__["a" /* default */].initialize().then(function () {
      _this.tenantName = __WEBPACK_IMPORTED_MODULE_1__tenant__["a" /* default */].name;
    });
  },
  methods: {
    sendContactMessage: function sendContactMessage(contact) {
      var _this2 = this;

      var message = 'New Contact Us request' + '\nEmail: ' + contact.email + '\n' + contact.message;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("" + '/api/contact-us', message).then(function () {
        _this2.contactSuccess = true;
      }).catch(function (error) {
        _this2.contactSuccess = true;
        console.log(error);
      });
    }
  },
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "H1VY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "one section"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "3em",
      "padding-bottom": "3em"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('article', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('h1', {
    staticClass: "subtitle is-2 hide-mobile"
  }, [_vm._v("\n              Automate condo association insurance certificate requests\n            ")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle is-3 hide-desktop"
  }, [_vm._v("\n              Automate condo association insurance certificate requests\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              We provide a simple, cost effective solution to remove the burden of condo association evidence of insurance requests from\n              banks and property owners.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n              Contact us now for a free, no obligation trial and assistance getting started.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button is-success is-large",
    on: {
      "click": function($event) {
        _vm.showContactForm = true
      }
    }
  }, [_vm._v("Contact Us")])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "section two"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Manage your associations, policies and coverage details\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Once you set up an association, you will get a direct link for requesters to access the applicable evidence of insurance\n            certificate. Decide on privacy controls and distribute the link to anyone who needs access to the certificate to streamline the process and\n            provide better service to your associations.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            For more information, read our\n            "), _c('router-link', {
    staticClass: "has-text-info",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("Getting Started")]), _vm._v(" page.\n          ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Simple monthly pricing\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Unlimited associations and requests for a flat monthly price.\n            "), _c('a', {
    staticClass: "has-text-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showContactForm = true
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" for a special introductory rate.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Try it out\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Try a demo request now and generate a sample EOI certificate.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link",
    attrs: {
      "to": "/certificates/arrowig/ABC123"
    }
  }, [_vm._v("Demo")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "section three"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              Do you need an insurance certificate?\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/certificates"
    }
  }, [_vm._v("Search By Association")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              Broker Login\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n              Certificate of Property Insurance Form\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/fillable-certificate-of-property-insurance-form"
    }
  }, [_vm._v("Online Fillable Form")])], 1)])])])]), _vm._v(" "), _c('Footer'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showContactForm
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  })]), _vm._v(" "), (!_vm.contactSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter your message, we'll respond as quickly as possible"
    },
    domProps: {
      "value": (_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.sendContactMessage(_vm.contact)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.contactSuccess) ? _c('div', [_vm._m(2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showContactForm = false
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column hide-mobile"
  }, [_c('figure', {
    staticClass: "image",
    staticStyle: {
      "margin-left": "10%",
      "min-height": "330px"
    }
  }, [_c('img', {
    attrs: {
      "id": "cta-image",
      "src": "/static/img/LandingPageCertificateForm.jpg"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column hide-mobile"
  }, [_c('figure', {
    staticClass: "image center-image",
    staticStyle: {
      "min-height": "358px"
    }
  }, [_c('img', {
    attrs: {
      "id": "cta-image",
      "src": "/static/img/LandingPageManageAssociations.jpg"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you for contacting us. We will return your message as soon as possible.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HVY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JDfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "min-height": "35rem"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "request-title"
  }, [_vm._v("Request Certificate of Property Insurance")]), _vm._v(" "), (_vm.stage === 1) ? _c('AssociationPin', {
    attrs: {
      "hasTenant": _vm.hasTenant,
      "agencies": _vm.agencies,
      "Request": _vm.Request,
      "showNotFound": _vm.showNotFound
    },
    on: {
      "tenantSelected": _vm.tenantSelected,
      "next": _vm.getAssociation,
      "cancel": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 2) ? _c('PropertyInformation', {
    attrs: {
      "Request": _vm.Request
    },
    on: {
      "next": _vm.next,
      "previous": _vm.previous,
      "cancel": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 3) ? _c('FinalizeRequest', {
    attrs: {
      "Request": _vm.Request
    },
    on: {
      "finalize": _vm.finalize,
      "previous": _vm.previous,
      "cancel": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 4) ? _c('RequestComplete', {
    attrs: {
      "accord24": _vm.Request.Association.Accord24,
      "association": _vm.Request.Association
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tenantLongName != null && _vm.tenantPhoneNumber != null) ? _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "has-text-centered has-text-grey is-size-6",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Questions or issues? Call " + _vm._s(_vm.tenantLongName) + " at " + _vm._s(_vm.tenantPhoneNumber) + ".")])]) : _vm._e()], 1)]), _vm._v(" "), _c('Footer')], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KQvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("vpE9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fea30ff8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("cjOH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fea30ff8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KSCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__("ODK2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Documentation',
  data: function data() {
    return {
      done: false
    };
  },
  created: function created() {
    window.document.title = 'Managing Associations and Evidence of Insurance Requests';
  },
  mounted: function mounted() {
    this.done = true;
  },
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "LTxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Association_vue__ = __webpack_require__("fTdJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_978aa3ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Association_vue__ = __webpack_require__("0mr6");
function injectStyle (ssrContext) {
  __webpack_require__("HVY0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-978aa3ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Association_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_978aa3ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Association_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("1XP8");
function injectStyle (ssrContext) {
  __webpack_require__("UcJI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MP1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyInformation_vue__ = __webpack_require__("vatg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d63d2f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyInformation_vue__ = __webpack_require__("gqOr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d63d2f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyInformation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUDq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestsList_vue__ = __webpack_require__("SRFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65cab6e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RequestsList_vue__ = __webpack_require__("d/lJ");
function injectStyle (ssrContext) {
  __webpack_require__("6Rv6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65cab6e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65cab6e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RequestsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Select"].name, __WEBPACK_IMPORTED_MODULE_2_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Option"].name, __WEBPACK_IMPORTED_MODULE_2_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Popover"].name, __WEBPACK_IMPORTED_MODULE_2_element_ui__["Popover"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Dropdown"].name, __WEBPACK_IMPORTED_MODULE_2_element_ui__["Dropdown"]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "ODK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("Wqk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66192e76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("4N5N");
function injectStyle (ssrContext) {
  __webpack_require__("5eNK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66192e76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66192e76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pd1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      Locate Homeowners Association\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [(!_vm.hasTenant) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Association")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('el-select', {
    staticClass: "arrow-select",
    attrs: {
      "filterable": "",
      "placeholder": "Select Association"
    },
    on: {
      "change": function($event) {
        _vm.setTenant(_vm.selectedAssociation)
      }
    },
    model: {
      value: (_vm.selectedAssociation),
      callback: function($$v) {
        _vm.selectedAssociation = $$v
      },
      expression: "selectedAssociation"
    }
  }, _vm._l((_vm.associations), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Association Pin Number")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.PinNumber),
      expression: "Request.PinNumber"
    }],
    staticClass: "input",
    class: {
      'is-required': _vm.noPIN
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Pin Number"
    },
    domProps: {
      "value": (_vm.Request.PinNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.next()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "PinNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("Next")])])])]), _vm._v(" "), (_vm.submitted && !_vm.showNotFound) ? _c('div', {
    staticClass: "column is-half has-text-centered opaque",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Looking up your Certificate of Property Insurance...")])]) : _vm._e(), _vm._v(" "), (_vm.showNotFound) ? _c('div', {
    staticClass: "column is-half has-text-centered opaque",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('p', [_vm._v("The association was not found, did you enter the correct PIN number?")])]) : _vm._e(), _vm._v(" "), (_vm.noPIN) ? _c('div', {
    staticClass: "column is-half has-text-centered opaque",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('p', [_vm._v("Please enter PIN number.")])]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RVR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssociationsList_vue__ = __webpack_require__("2kZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3e2adc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AssociationsList_vue__ = __webpack_require__("vcQr");
function injectStyle (ssrContext) {
  __webpack_require__("Ssmz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3e2adc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssociationsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3e2adc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AssociationsList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SRFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestsList',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      deleteIndex: 0,
      deleteText: '',
      disableDeleteContinue: true,
      openDropdownRef: {},
      requests: []
    };
  },
  methods: {
    initialize: function initialize() {
      var _this = this;

      window.document.title = 'Certificate Requests';
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests').once('value').then(function (snapshot) {
        _this.requests = __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].getArray(snapshot.val());
        _this.requests.reverse();
        _this.isLoading = false;
      });
    },
    toggleActive: function toggleActive(ref) {
      if (this.openDropdownRef.classList) {
        this.away();
        return;
      }
      if (this.$refs[ref]) {
        this.openDropdownRef = this.$refs[ref][0];
        this.openDropdownRef.classList.add('is-active');
      }
    },
    openDeleteModal: function openDeleteModal(index) {
      this.deleteIndex = index;
      this.showDeleteModal = true;
    },
    checkDeleteText: function checkDeleteText(text) {
      if (text === 'DELETE') {
        this.disableDeleteContinue = false;
      } else {
        this.disableDeleteContinue = true;
      }
    },
    deleteRequest: function deleteRequest(index) {
      var _this2 = this;

      var key = this.requests[index].key;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests/' + key).remove().then(function () {
        _this2.deleteIndex = index;
        _this2.showDeleteModal = false;
        _this2.deleteText = '';
        _this2.disableDeleteContinue = true;
        _this2.initialize();
      });
    },
    away: function away() {
      if (this.openDropdownRef.classList) {
        this.openDropdownRef.classList.remove('is-active');
        this.openDropdownRef = {};
      }
    },
    formatDate: function formatDate(d) {
      if (d) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(d).format('MM-DD-YYYY');
      }
      return null;
    }
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].initialize().then(function () {
      _this3.initialize();
    });
  }
});

/***/ }),

/***/ "Ssmz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Swjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("q6Ae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);

var config = {
  apiKey: 'AIzaSyB8-MwZUjJFfkgJVExYxQ_f_uThHFjlzeg',
  authDomain: 'arrowcerts.firebaseapp.com',
  databaseURL: 'https://arrowcerts.firebaseio.com',
  projectId: 'arrowcerts',
  storageBucket: 'gs://arrowcerts.appspot.com',
  messagingSenderId: '855821689425'
};

var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);
var firebaseDb = firebaseApp.database();
var firebaseStorage = firebaseApp.storage();

var tenant = {};

tenant.initialize = function () {
  return new __WEBPACK_IMPORTED_MODULE_0_firebase__["Promise"](function (resolve, reject) {
    if (false) {
      tenant.name = 'arrowig';
      return firebaseApp.auth().onAuthStateChanged(function (user) {
        if (user) {
          tenant.user = user;
          resolve();
        }
      });
    } else {
      // try to get it from session storage
      var tenantName = window.sessionStorage.getItem('tenantName');
      if (tenantName) {
        tenant.name = tenantName;
        resolve();
      }

      // get the user
      return firebaseApp.auth().onAuthStateChanged(function (user) {
        if (user) {
          tenant.user = user;

          // if we didn't get tenant name from storage, then get it from the user's default tenant in firebase
          if (!tenant.name) {
            var convertedEmail = user.email.toLowerCase().replace(/\./g, '%2E');
            return firebaseDb.ref('users/' + convertedEmail).once('value').then(function (snapshot) {
              // set it in session storage for next time
              if (snapshot.val()) {
                window.sessionStorage.setItem('tenantName', snapshot.val());
                tenant.name = snapshot.val();
              }
              resolve();
            });
          }
        } else {
          tenant.user = null;
          resolve();
        }
      });
    }
  });
};

tenant.firebaseDb = firebaseDb;
tenant.firebaseStorage = firebaseStorage;

tenant.ref = function (refName) {
  return firebaseDb.ref('agencies/' + tenant.name + '/' + refName);
};
tenant.agencyRef = function () {
  return firebaseDb.ref('agencies/' + tenant.name);
};

tenant.getArray = function (obj) {
  var arr = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var arrayItem = obj[key];
      arrayItem.key = key;
      arr.push(arrayItem);
    }
  }
  return arr;
};

tenant.app = firebaseApp;

/* harmony default export */ __webpack_exports__["a"] = (tenant);

/***/ }),

/***/ "TRhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestViewer_vue__ = __webpack_require__("z5VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddd80c9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RequestViewer_vue__ = __webpack_require__("/WL8");
function injectStyle (ssrContext) {
  __webpack_require__("TuWb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddd80c9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddd80c9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RequestViewer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TuWb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UcJI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VjfW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("Cbbb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e51d1b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("XnWR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e51d1b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WHG4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wqk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',
  data: function data() {
    return {
      showContactForm: false,
      contactSuccess: false,
      contact: {
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  methods: {
    getYear: function getYear() {
      return new Date().getFullYear();
    },
    sendContactMessage: function sendContactMessage(contact) {
      var _this = this;

      var message = 'New Contact Us request' + '\nEmail: ' + contact.email + '\n' + contact.message;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("" + '/api/contact-us', message).then(function () {
        _this.contactSuccess = true;
      }).catch(function (error) {
        _this.contactSuccess = true;
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "X7+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_associations_Accord24__ = __webpack_require__("DQXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_accord_util__ = __webpack_require__("+zJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestViewer',
  data: function data() {
    return {
      isLoading: true,
      isSaving: false,
      isGeneratingPdf: false,
      showEmailModal: false,
      emailSuccess: false,
      emailError: false,
      emailInvalidTo: false,
      emailInvalidCc: false,
      isSendingContactUsEmail: false,
      isSendingEmail: false,
      contact: {
        email: ''
      },
      emailData: {
        to: '',
        cc: '',
        message: null
      },
      request: {},
      fileName: '',
      pdflink: '',
      accord24: {}
    };
  },
  created: function created() {
    var _this = this;

    window.scrollTo(0, 0);
    __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].initialize().then(function () {
      _this.initialize(_this.$route);
    });
  },
  methods: {
    initialize: function initialize(route) {
      window.document.title = 'Online Fillable Certificate of Property Insurance';
      this.isLoading = false;
    },
    putRequest: function putRequest(request) {
      var _this2 = this;

      var key = this.$route.params.id;
      this.isSaving = true;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests/' + key).set(request).then(function () {
        _this2.isSaving = false;
      });
    },
    getPdf: function getPdf() {
      var _this3 = this;

      this.isGeneratingPdf = true;

      // go ahead and do a save
      var key = this.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests/' + key).set(this.request);

      var accordForm = this.$refs['accord'].$el.innerHTML;
      var rawHTML = this.getAccordDOM(accordForm);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("" + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        _this3.isGeneratingPdf = false;
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf');
        } else {
          _this3.pdflink = window.URL.createObjectURL(blob);
          _this3.fileName = 'InsuranceCertificate.pdf';
          _this3.$nextTick(function () {
            _this3.$refs['pdf'].click();
          });
        }
      }).catch(function (error) {
        _this3.isGeneratingPdf = false;
        console.log(error);
      });
    },
    getAccordDOM: function getAccordDOM(accordForm) {
      return __WEBPACK_IMPORTED_MODULE_2__utilities_accord_util__["a" /* default */].getAccordDOM(accordForm);
    },
    getAttachmentName: function getAttachmentName() {
      return 'Certificate_of_Property_Insurance.pdf';
    },
    openEmailModal: function openEmailModal() {
      if (!this.emailData.message) {
        this.emailData.message = 'Please see attached Certificate of Insurance.';
        this.showEmailModal = true;
      } else {
        this.showEmailModal = true;
      }
    },
    closeEmailModal: function closeEmailModal() {
      this.showEmailModal = false;
      this.emailSuccess = false;
      this.emailError = false;
    },
    validateEmailForm: function validateEmailForm(emailData) {
      var foundError = false;
      var to = emailData.to;
      if (!to || to.indexOf('@') < 1 || to.indexOf('.') < 2) {
        this.emailInvalidTo = true;
        foundError = true;
      } else {
        this.emailInvalidTo = false;
      }

      var cc = emailData.cc;
      if (cc && (cc.indexOf('@') < 1 || cc.indexOf('.') < 2)) {
        this.emailInvalidCc = true;
        foundError = true;
      } else {
        this.emailInvalidCc = false;
      }

      if (foundError) {
        return false;
      }

      return true;
    },
    sendContactMessage: function sendContactMessage(contact) {
      var _this4 = this;

      if (!contact.email) {
        this.invalidContactEmail;
      }
      this.isSendingContactUsEmail = true;
      var message = 'New Contact Us request from fillable form \nEmail:  ' + contact.email;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("" + '/api/contact-us', message).then(function () {
        _this4.contactSuccess = true;
        _this4.isSendingContactUsEmail = false;
      }).catch(function (error) {
        _this4.contactSuccess = true;
        console.log(error);
      });
    },
    sendEmailMessage: function sendEmailMessage(emailData) {
      var _this5 = this;

      if (!this.validateEmailForm(emailData)) {
        return;
      }
      var accordForm = this.$refs['accord'].$el.innerHTML;
      emailData.rawHTML = this.getAccordDOM(accordForm);
      emailData.attachmentName = this.getAttachmentName();
      emailData.subject = 'Certificate of Property Insurance';
      if (emailData.message.indexOf('https://www.getcoi.com') < 0) {
        emailData.message += '\n\n\n\n_____________________________\n\nThis certificate was provided by GetCOI. We help independent insurance brokers automate certificate of insurance requests.\nhttps://www.getcoi.com\n        ';
      }

      this.isSendingEmail = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("" + '/api/certificates/email-pdf', emailData).then(function (response) {
        _this5.emailSuccess = true;
        _this5.isSendingEmail = false;
      }).catch(function (error) {
        _this5.isSendingEmail = false;
        _this5.emailError = true;
        console.log(error);
      });
    },
    cancel: function cancel() {
      this.$router.push('/');
    }
  },
  watch: {
    '$route': function $route() {
      this.initialize(this.$route);
    },

    floatResearch: function floatResearch() {
      this.researchScroll();
    }
  },
  components: {
    Accord24: __WEBPACK_IMPORTED_MODULE_1__components_associations_Accord24__["a" /* default */]
  }
});

/***/ }),

/***/ "XQW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "hero one is-dark",
    staticStyle: {
      "margin-top": "25px",
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [(!_vm.contactSuccess) ? _c('div', {
    staticClass: "columns is-vcentered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control has-icons-left is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }],
    staticClass: "input is-flat required email",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.isSendingContactUsEmail
    },
    on: {
      "click": function($event) {
        _vm.sendContactMessage(_vm.contact)
      }
    }
  }, [_vm._v("Reach Out")])])])])]) : _vm._e(), _vm._v(" "), (_vm.contactSuccess) ? _c('div', {
    staticClass: "columns is-vcentered"
  }, [_vm._m(2)]) : _vm._e()])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "field crud-buttons is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link hide-mobile",
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_vm._v("\n            Email (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-envelope-open",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-envelope-open"
  })])]), _vm._v(" "), _c('span', [_c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_vm._v("\n            Download (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-download"
  })])])]), _vm._v(" "), _vm._m(4)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('Accord24', {
    attrs: {
      "accord24": _vm.accord24,
      "requestViewer": true
    }
  }), _vm._v(" "), _c('Accord24', {
    ref: "accord",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accord24": _vm.accord24,
      "readonly": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showEmailModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Email Certificate")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  })]), _vm._v(" "), (!_vm.emailSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.to),
      expression: "emailData.to"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "to", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidTo) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CC")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.cc),
      expression: "emailData.cc"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.cc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "cc", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidCc) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.getAttachmentName()))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.message),
      expression: "emailData.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter message"
    },
    domProps: {
      "value": (_vm.emailData.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.emailError) ? _c('section', {
    staticClass: "modal-card-body"
  }, [_c('hr'), _vm._v(" Error sending email! Please try again or download PDF and send externally.\n          "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    class: {
      'is-loading': _vm.isSendingEmail
    },
    on: {
      "click": function($event) {
        _vm.sendEmailMessage(_vm.emailData)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.emailSuccess) ? _c('div', [_vm._m(5), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-half"
  }, [_c('h3', {
    staticClass: "title is-6"
  }, [_c('strong', [_vm._v("If you find this fillable Certificate of Property Insurance form valuable, please reach out to us. We would\n                  "), _c('u', [_vm._v("love")]), _vm._v(" to hear from you.")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Thank you for your support!")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Online Fillable Certificate of Property Insurance")]), _vm._v(" "), _c('hr'), _vm._v(" While we offer a full featured EOI management system, you can use the following free, online fillable Certificate\n        of Property Insurance form to respond to Evidence of Insurance requests as well. Once you complete the form below,\n        you can either download a PDF certificate directly or email the certificate.\n        "), _c('h3', {
    staticClass: "title is-6",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_vm._v("Guidelines for completing the form")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("We recommend to include all insurers and policies, not limited to just property insurance. This can include\n              Commercial General Liability, Flood, Employee Theft and Umbrella insurance.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Include a good description of the properties and buildings covered by the insurance in the LOCATION OF PREMISES/DESCRIPTION\n              OF PROPERTIES field.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Use the ADDITIONAL REMARKS page to further elaborate about properties and coverage.\n            ")]), _vm._v(" "), _c('li', [_vm._v("For more guidance, have a look at this\n              "), _c('a', {
    attrs: {
      "href": "/static/InsuranceCertificate.pdf",
      "title": "Sample Certificate of Property Insurance",
      "alt": "Sample Certificate of Property Insurance"
    }
  }, [_vm._v("Sample Certificate of Property Insurance")]), _vm._v(".\n            ")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section hide-mobile"
  }, [_c('h3', {
    staticClass: "title is-6"
  }, [_vm._v("Certificate of Property Insurance Form")]), _vm._v(" "), _c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you, your email has been sent.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XbJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__("ODK2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Welcome',
  created: function created() {
    window.document.title = 'Welcome | Property Insurance Certificates';
  },
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "XnWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "is-fullheight is-bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('h1', {
    staticClass: "title is-4"
  }, [_vm._v("\n              Register an Account\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "jsmith@example.org"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), (_vm.emailMessage) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.emailMessage))]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Enter Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), (_vm.message) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.passwordConfirm),
      expression: "user.passwordConfirm"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.user.passwordConfirm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.register(_vm.user)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "passwordConfirm", $event.target.value)
      }
    }
  })]), (_vm.message) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.register(_vm.user)
      }
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('button', {
    staticClass: "button is-default"
  }, [_vm._v("Cancel")])])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Already Registered?")])], 1)])])])])]), _vm._v(" "), _c('Footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_request_Status__ = __webpack_require__("Bi9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_request_Request__ = __webpack_require__("5tXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_associations_Accord24__ = __webpack_require__("DQXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_associations_AssociationsList__ = __webpack_require__("RVR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_request_RequestsList__ = __webpack_require__("MUDq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_request_RequestViewer__ = __webpack_require__("TRhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_request_PublicRequest__ = __webpack_require__("8IRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_associations_Association__ = __webpack_require__("LTxk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_user_Register__ = __webpack_require__("VjfW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_user_Login__ = __webpack_require__("KQvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Documentation__ = __webpack_require__("ePYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Welcome__ = __webpack_require__("FJN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tenant__ = __webpack_require__("Swjk");

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */] }, { path: '/certificates/:tenantName', component: __WEBPACK_IMPORTED_MODULE_4__components_request_Request__["a" /* default */] }, { path: '/certificates/:tenantName/:pinNumber', component: __WEBPACK_IMPORTED_MODULE_4__components_request_Request__["a" /* default */] }, { path: '/certificates', component: __WEBPACK_IMPORTED_MODULE_4__components_request_Request__["a" /* default */] }, { path: '/status/:requestId', component: __WEBPACK_IMPORTED_MODULE_3__components_request_Status__["a" /* default */] }, { path: '/requests/', component: __WEBPACK_IMPORTED_MODULE_7__components_request_RequestsList__["a" /* default */], meta: { requiresAuth: true } }, { path: '/requests/:id', component: __WEBPACK_IMPORTED_MODULE_8__components_request_RequestViewer__["a" /* default */], meta: { requiresAuth: true } }, { path: '/associations/', component: __WEBPACK_IMPORTED_MODULE_6__components_associations_AssociationsList__["a" /* default */], meta: { requiresAuth: true } }, { path: '/associations/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_associations_Association__["a" /* default */], meta: { requiresAuth: true } }, { path: '/associations/:id/accord', component: __WEBPACK_IMPORTED_MODULE_5__components_associations_Accord24__["a" /* default */], meta: { requiresAuth: true } }, { path: '/fillable-certificate-of-property-insurance-form', component: __WEBPACK_IMPORTED_MODULE_9__components_request_PublicRequest__["a" /* default */] }, { path: '/register/', component: __WEBPACK_IMPORTED_MODULE_11__components_user_Register__["a" /* default */] }, { path: '/documentation/', component: __WEBPACK_IMPORTED_MODULE_13__components_Documentation__["a" /* default */] }, { path: '/welcome/', component: __WEBPACK_IMPORTED_MODULE_14__components_Welcome__["a" /* default */] }, { path: '/login/', component: __WEBPACK_IMPORTED_MODULE_12__components_user_Login__["a" /* default */] }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth) {
    __WEBPACK_IMPORTED_MODULE_15__tenant__["a" /* default */].app.auth().onAuthStateChanged(function (user) {
      if (user && !user.isAnonymous) {
        next();
      } else {
        var toPath = encodeURIComponent(to.path);
        next('/login?redir=' + toPath);
      }
    });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yai7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssociationPin_vue__ = __webpack_require__("k8rv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b0e6f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AssociationPin_vue__ = __webpack_require__("Pd1V");
function injectStyle (ssrContext) {
  __webpack_require__("0sG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21b0e6f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AssociationPin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21b0e6f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AssociationPin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c/kM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cjOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "is-fullheight is-bold"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('h1', {
    staticClass: "title is-4"
  }, [_vm._v("\n              Login\n            ")]), _vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n            "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Enter Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login(_vm.email, _vm.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.login(_vm.email, _vm.password)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('button', {
    staticClass: "button is-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('p', {
    staticClass: "has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("New User?")])], 1)])])])])]), _vm._v(" "), _c('Footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d/lJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container list-page-header"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "list-body container"
  }, [_c('section', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.requests), function(request, index) {
    return _c('tr', {
      key: request['.key']
    }, [_c('td', [_c('router-link', {
      staticClass: "has-text-info",
      attrs: {
        "to": '/requests/' + request.key
      }
    }, [_vm._v(_vm._s(request.Association.Name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(request.Date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.RequesterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.RequesterEmail))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.PropertyOwnerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.PropertyAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.LoanNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.Association.Accord24.CertificateHolder))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30px"
      }
    }, [_c('div', {
      staticClass: "is-pulled-right"
    }, [_c('div', {
      ref: 'associationRow' + index,
      refInFor: true,
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-trigger"
    }, [_c('div', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.away),
        expression: "away"
      }],
      staticClass: "icon is-small fa-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleActive('associationRow' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "id": "dropdown-menu3",
        "role": "menu"
      }
    }, [_c('div', {
      staticClass: "dropdown-content"
    }, [_c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.openDeleteModal(index)
        }
      }
    }, [_vm._v("\n                            Delete Request\n                          ")])])])])])])])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showDeleteModal) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('h5', [_vm._v("Enter DELETE below to permanently delete request from " + _vm._s(_vm.requests[_vm.deleteIndex].RequesterEmail) + " on " + _vm._s(_vm.formatDate(_vm.requests[_vm.deleteIndex].Date)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin": "-20px 0px 30px 0px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteText),
      expression: "deleteText"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter DELETE"
    },
    domProps: {
      "value": (_vm.deleteText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.deleteText = $event.target.value
      }, function($event) {
        _vm.checkDeleteText(_vm.deleteText)
      }]
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": _vm.disableDeleteContinue
    },
    on: {
      "click": function($event) {
        _vm.deleteRequest(_vm.deleteIndex)
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Certificate Requests")]), _vm._v(" "), _c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Association")]), _vm._v(" "), _c('th', [_vm._v("Request Date")]), _vm._v(" "), _c('th', [_vm._v("Requester Name")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Property Owner")]), _vm._v(" "), _c('th', [_vm._v("Address")]), _vm._v(" "), _c('th', [_vm._v("Loan Number")]), _vm._v(" "), _c('th', [_vm._v("Cert. Holder")]), _vm._v(" "), _c('th')])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d5GU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_associations_Accord24__ = __webpack_require__("DQXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_accord_util__ = __webpack_require__("+zJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestComplete',
  props: ['accord24', 'association'],
  data: function data() {
    return {
      loading: true,
      isIE: false,
      submitted: false,
      found: false,
      pdflink: '',
      fileName: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var accordForm = _this.$refs['accord'].$el.outerHTML;
      var rawHTML = _this.getAccordDOM(accordForm);
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("" + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then(function (response) {
        _this.loading = false;
        var blob = new Blob([response.data], { type: 'application/pdf' });
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          _this.isIE = true;
          _this.$nextTick(function () {
            _this.$refs['pdfIE'].addEventListener('click', function () {
              window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf');
            });
          });
        } else {
          _this.pdflink = window.URL.createObjectURL(blob);
          _this.fileName = 'InsuranceCertificate.pdf';
        }
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    });
  },

  methods: {
    next: function next() {
      var _this2 = this;

      this.submitted = true;
      this.found = false;
      setTimeout(function () {
        _this2.$emit('next', 2);
        _this2.submitted = false;
        _this2.found = true;
      }, 2500);
    },
    previous: function previous() {
      this.$emit('previous');
    },
    getAccordDOM: function getAccordDOM(accordForm) {
      return __WEBPACK_IMPORTED_MODULE_1__utilities_accord_util__["a" /* default */].getAccordDOM(accordForm);
    }
  },
  components: {
    Accord24: __WEBPACK_IMPORTED_MODULE_0__components_associations_Accord24__["a" /* default */]
  }
});

/***/ }),

/***/ "ePYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentation_vue__ = __webpack_require__("KSCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ea26eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Documentation_vue__ = __webpack_require__("4b0A");
function injectStyle (ssrContext) {
  __webpack_require__("c/kM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12ea26eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Documentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ea26eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Documentation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f63L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinalizeRequest_vue__ = __webpack_require__("6lqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e11ad2fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FinalizeRequest_vue__ = __webpack_require__("1KpB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinalizeRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e11ad2fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FinalizeRequest_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fTdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_associations_Accord24__ = __webpack_require__("DQXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_accord_util__ = __webpack_require__("+zJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Association',
  data: function data() {
    return {
      isLoading: true,
      isSaving: false,
      isAttaching: false,
      isGeneratingPdf: false,
      isNewAssociation: false,
      showCopyToRequestModal: false,
      showLinkPopover: false,
      missingName: false,
      missingPinNumber: false,
      duplicatePinNumber: false,
      invalidPinNumber: false,
      shortPinNumber: false,
      association: {
        PinNumber: '',
        Name: '',
        Status: 'draft',
        Attachments: [],
        Accord24: {
          AuthorizedRepresentative: '',
          CertificateHolder: '',
          CertificateNumber: '',
          ContactEmailAddress: '',
          ContactName: '',
          FaxNumber: '',
          Insured: '',
          InsurerA_NAIC: '',
          InsurerA_Name: '',
          InsurerB_NAIC: '',
          InsurerB_Name: '',
          InsurerC_NAIC: '',
          InsurerC_Name: '',
          InsurerD_NAIC: '',
          InsurerD_Name: '',
          InsurerE_NAIC: '',
          InsurerE_Name: '',
          InsurerF_NAIC: '',
          InsurerF_Name: '',
          InsurerLetter1: '',
          InsurerLetter1_BlanketBuildingAndPersonalPropertyLimit: '',
          InsurerLetter1_BlanketBuildingLimit: '',
          InsurerLetter1_BlanketPersonalPropertyLimits: '',
          InsurerLetter1_BuildingDeductible: '',
          InsurerLetter1_BuildingLimits: '',
          InsurerLetter1_BusinessIncomeLimit: '',
          InsurerLetter1_EarthquakeDeductible: '',
          InsurerLetter1_EffectiveDate: '',
          InsurerLetter1_ExpirationDate: '',
          InsurerLetter1_ExtraExpenseLimit: '',
          InsurerLetter1_FloodDeductible: '',
          InsurerLetter1_IsBasic: '',
          InsurerLetter1_IsBlanketBuilding: '',
          InsurerLetter1_IsBlanketBuildingAndPersonalProperty: '',
          InsurerLetter1_IsBlanketPersonalProperty: '',
          InsurerLetter1_IsBroad: '',
          InsurerLetter1_IsBuilding: '',
          InsurerLetter1_IsBusinessIncome: '',
          InsurerLetter1_IsEarthquake: '',
          InsurerLetter1_IsExtraExpense: '',
          InsurerLetter1_IsFlood: '',
          InsurerLetter1_IsOtherInsurance1: '',
          InsurerLetter1_IsOtherInsurance2: '',
          InsurerLetter1_IsOtherProperty1: '',
          InsurerLetter1_IsOtherProperty2: '',
          InsurerLetter1_IsPersonalProperty: '',
          InsurerLetter1_IsProperty: '',
          InsurerLetter1_IsRentalValue: '',
          InsurerLetter1_IsSpecial: '',
          InsurerLetter1_IsWind: '',
          InsurerLetter1_OtherDeductible1: '',
          InsurerLetter1_OtherDeductible2: '',
          InsurerLetter1_OtherInsurance1: '',
          InsurerLetter1_OtherInsurance2: '',
          InsurerLetter1_OtherProperty1: '',
          InsurerLetter1_OtherProperty2: '',
          InsurerLetter1_OtherPropertyLimit1: '',
          InsurerLetter1_OtherPropertyLimit2: '',
          InsurerLetter1_PersonalPropertyLimit: '',
          InsurerLetter1_PolicyNumber: '',
          InsurerLetter1_RentalValueLimit: '',
          InsurerLetter1_WindDeductible: '',
          InsurerLetter2: '',
          InsurerLetter2_EffectiveDate: '',
          InsurerLetter2_ExpirationDate: '',
          InsurerLetter2_IsInlandMarine: '',
          InsurerLetter2_IsNamedPerils: '',
          InsurerLetter2_IsOtherInsurance4: '',
          InsurerLetter2_IsOtherProperty1: '',
          InsurerLetter2_IsOtherProperty2: '',
          InsurerLetter2_IsOtherProperty3: '',
          InsurerLetter2_IsOtherProperty4: '',
          InsurerLetter2_OtherInsurance4: '',
          InsurerLetter2_OtherProperty1: '',
          InsurerLetter2_OtherProperty2: '',
          InsurerLetter2_OtherProperty3: '',
          InsurerLetter2_OtherProperty4: '',
          InsurerLetter2_OtherPropertyLimit1: '',
          InsurerLetter2_OtherPropertyLimit2: '',
          InsurerLetter2_OtherPropertyLimit3: '',
          InsurerLetter2_OtherPropertyLimit4: '',
          InsurerLetter2_PolicyNumber: '',
          InsurerLetter2_PolicyType: '',
          InsurerLetter3: '',
          InsurerLetter3_EffectiveDate: '',
          InsurerLetter3_ExpirationDate: '',
          InsurerLetter3_IsCrime: '',
          InsurerLetter3_IsOtherProperty1: '',
          InsurerLetter3_IsOtherProperty2: '',
          InsurerLetter3_IsOtherProperty3: '',
          InsurerLetter3_OtherProperty1: '',
          InsurerLetter3_OtherProperty2: '',
          InsurerLetter3_OtherProperty3: '',
          InsurerLetter3_OtherPropertyLimit1: '',
          InsurerLetter3_OtherPropertyLimit2: '',
          InsurerLetter3_OtherPropertyLimit3: '',
          InsurerLetter3_PolicyNumber: '',
          InsurerLetter3_PolicyType: '',
          InsurerLetter4: '',
          InsurerLetter4_EffectiveDate: '',
          InsurerLetter4_ExpirationDate: '',
          InsurerLetter4_IsBoiler: '',
          InsurerLetter4_IsOtherProperty1: '',
          InsurerLetter4_IsOtherProperty2: '',
          InsurerLetter4_OtherProperty1: '',
          InsurerLetter4_OtherProperty2: '',
          InsurerLetter4_OtherPropertyLimit1: '',
          InsurerLetter4_OtherPropertyLimit2: '',
          InsurerLetter4_PolicyNumber: '',
          InsurerLetter5: '',
          InsurerLetter5_EffectiveDate: '',
          InsurerLetter5_ExpirationDate: '',
          InsurerLetter5_IsOtherProperty1: '',
          InsurerLetter5_IsOtherProperty2: '',
          InsurerLetter5_OtherInsurance1: '',
          InsurerLetter5_OtherProperty: '',
          InsurerLetter5_OtherProperty2: '',
          InsurerLetter5_OtherPropertyLimit1: '',
          InsurerLetter5_OtherPropertyLimit2: '',
          InsurerLetter5_PolicyNumber: '',
          PhoneNumber: '',
          Producer: '',
          ProducerCustomerId: '',
          PropertyDescription: '',
          RevisionNumber: '',
          SpecialConditions: ''
        }
      },
      request: {},
      fileName: '',
      pdflink: ''
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].initialize().then(function () {
      _this.initialize(_this.$route);
    });
  },
  methods: {
    initialize: function initialize(route) {
      window.document.title = 'Associations';
      this.isNewAssociation = route.params.id === 'new';
      if (!this.isNewAssociation) {
        this.fetchAssociation(route.params.id);
      } else {
        this.isLoading = false;
      }
    },
    fetchAssociation: function fetchAssociation(Id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations/' + Id).once('value').then(function (snapshot) {
        _this2.association = snapshot.val();
        console.log(_this2.association);
        if (!_this2.association.Attachments) {
          _this2.association.Attachments = [];
          _this2.putAssociation(_this2.association);
        }
        _this2.isLoading = false;
      });
    },
    postAssociation: function postAssociation(association) {
      var _this3 = this;

      if (!this.validate(association)) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('pins').once('value').then(function (snapshot) {
        var allPins = snapshot.val();
        for (var pinKey in allPins) {
          if (allPins.hasOwnProperty(pinKey)) {
            if (allPins[pinKey] === association.PinNumber) {
              _this3.invalidPinNumber = true;
              _this3.duplicatePinNumber = true;
              _this3.isSaving = false;
              return;
            }
          }
        }

        var response = __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations').push(association);
        _this3.isNewAssociation = false;

        _this3.setReferenceData(response.key, association);
        _this3.$router.push('/associations/' + response.key);
      });
    },
    putAssociation: function putAssociation(association) {
      var _this4 = this;

      if (!this.validate(association)) {
        return;
      }

      var key = this.$route.params.id;
      this.isSaving = true;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('pins').once('value').then(function (snapshot) {
        var allPins = snapshot.val();
        for (var pinKey in allPins) {
          if (allPins.hasOwnProperty(pinKey)) {
            if (pinKey !== key && allPins[pinKey] === association.PinNumber) {
              _this4.invalidPinNumber = true;
              _this4.duplicatePinNumber = true;
              _this4.isSaving = false;
              return;
            }
          }
        }

        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations/' + key).set(association).then(function () {
          _this4.isSaving = false;
        });
        _this4.setReferenceData(key, association);
      });
    },
    setReferenceData: function setReferenceData(key, association) {
      if (association.Status !== 'draft') {
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].name + '/associations/' + key).set(association.Name);
      }

      if (association.Status === 'draft') {
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('lists/agencies/' + __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].name + '/associations/' + key).remove();
      }

      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('pins/' + key).set(association.PinNumber);
    },
    validate: function validate(association) {
      this.missingPinNumber = false;
      this.missingName = false;
      this.invalidPinNumber = false;
      this.duplicatePinNumber = false;
      this.shortPinNumber = false;

      if (!association.PinNumber || !association.Name || association.PinNumber.length < 5) {
        if (!association.PinNumber) {
          this.invalidPinNumber = true;
          this.missingPinNumber = true;
        }
        if (!association.Name) {
          this.missingName = true;
        }
        if (association.PinNumber.length < 5) {
          this.invalidPinNumber = true;
          this.shortPinNumber = true;
        }
        return false;
      }

      return true;
    },
    postRequest: function postRequest(association) {
      var d = new Date();
      if (__WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].user) {
        var request = {
          Association: association,
          Date: d.toISOString(),
          RequesterEmail: __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].user.email
        };
        var response = __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests').push(request);
        this.$router.push('/requests/' + response.key);
      }
    },
    getPdf: function getPdf() {
      var _this5 = this;

      this.isGeneratingPdf = true;

      // go ahead and do a save
      var key = this.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('associations/' + key).set(this.association);

      var accordForm = this.$refs['accord'].$el.innerHTML;
      var rawHTML = this.getAccordDOM(accordForm);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("" + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        _this5.isGeneratingPdf = false;
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          _this5.isIE = true;
          window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf');
        } else {
          _this5.pdflink = window.URL.createObjectURL(blob);
          _this5.fileName = 'InsuranceCertificate.pdf';
          _this5.$nextTick(function () {
            _this5.$refs['pdf'].click();
          });
        }
      }).catch(function (error) {
        _this5.isGeneratingPdf = false;
        console.log(error);
      });
    },
    getAccordDOM: function getAccordDOM(accordForm) {
      return __WEBPACK_IMPORTED_MODULE_2__utilities_accord_util__["a" /* default */].getAccordDOM(accordForm);
    },
    cancel: function cancel() {
      this.$router.push('/associations');
    },
    attach: function attach() {
      document.getElementById('uploadInput').click();
    },
    handleFileSelected: function handleFileSelected() {
      var _this6 = this;

      var files = document.getElementById('uploadInput').files;

      var _loop = function _loop(i) {
        var file = files[i];
        var key = _this6.$route.params.id;

        var metadata = {
          contentType: 'application/pdf'
        };
        _this6.isAttaching = true;
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseStorage.ref().child('attachments/' + key + '/' + file.name).put(file, metadata).then(function (response) {
          if (_this6.association.Attachments) {
            _this6.association.Attachments.push({
              downloadURL: response.downloadURL,
              fileName: response.metadata.name
            });
            _this6.putAssociation(_this6.association);
            if (i === files.length - 1) {
              _this6.isAttaching = false;
            }
          }
        });
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
    },
    deleteAttachment: function deleteAttachment(attachment) {
      var _this7 = this;

      var key = this.$route.params.id;
      this.isAttaching = true;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseStorage.ref().child('attachments/' + key + '/' + attachment.fileName).delete().then(function () {
        var index = _this7.association.Attachments.findIndex(function (x) {
          return x.fileName === attachment.fileName;
        });
        _this7.association.Attachments.splice(index, 1);
        _this7.putAssociation(_this7.association);
        _this7.isAttaching = false;
      });
    }
  },
  watch: {
    '$route': function $route() {
      this.initialize(this.$route);
    }
  },
  computed: {
    link: function link() {
      return window.location.origin + '/certificates/' + __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].name + '/' + this.association.PinNumber;
    }
  },
  components: {
    Accord24: __WEBPACK_IMPORTED_MODULE_1__components_associations_Accord24__["a" /* default */]
  }
});

/***/ }),

/***/ "fe4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Accord24',
  props: ['accord24', 'readonly', 'requestViewer'],
  data: function data() {
    return {
      isLoading: false
    };
  },
  methods: {
    initialize: function initialize(route) {
      // window.document.title = 'Preview'
      // this.fetchAssociation(route.params.id)
    },
    translateCheckbox: function translateCheckbox(val) {
      if (val) {
        return 'X';
      }
      return '';
    },
    translateTextarea: function translateTextarea(val) {
      if (val) {
        return val.replace(/(?:\r\n|\r|\n)/g, '<br />');
      }
      return '';
    }
  },
  created: function created() {
    this.initialize(this.$route);
  },
  computed: {
    currentDate: function currentDate() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MM/DD/YYYY');
    }
  }
});

/***/ }),

/***/ "gqOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      Property Information\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Owner Full Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.PropertyOwnerName),
      expression: "Request.PropertyOwnerName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Owner Full Name"
    },
    domProps: {
      "value": (_vm.Request.PropertyOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "PropertyOwnerName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Property Address")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.PropertyAddress),
      expression: "Request.PropertyAddress"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Property Address"
    },
    domProps: {
      "value": (_vm.Request.PropertyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "PropertyAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Loan Number")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.LoanNumber),
      expression: "Request.LoanNumber"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Loan Number"
    },
    domProps: {
      "value": (_vm.Request.LoanNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "LoanNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Certificate Holder")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.CertificateHolder),
      expression: "Request.CertificateHolder"
    }],
    staticClass: "textarea",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Lender Certificiate Holder Information"
    },
    domProps: {
      "value": (_vm.Request.CertificateHolder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request, "CertificateHolder", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Request.Association.Name),
      expression: "Request.Association.Name"
    }],
    staticClass: "input",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Request.Association.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Request.Association, "Name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.submitted) ? _c('div', {
    staticClass: "has-text-centered opaque ",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x "
  }), _vm._v(" "), _c('p', [_vm._v("Updating Request...")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field is-grouped",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-outlined",
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("Next")])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("We have located your evidence of insurance. Please complete the fields and click next to continue.")]), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestComplete_vue__ = __webpack_require__("d5GU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d1ea94e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RequestComplete_vue__ = __webpack_require__("rgl/");
function injectStyle (ssrContext) {
  __webpack_require__("DWyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d1ea94e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RequestComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d1ea94e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RequestComplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k8rv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssociationPin',
  props: ['Request', 'showNotFound', 'hasTenant', 'agencies'],
  data: function data() {
    return {
      submitted: false,
      found: false,
      noPIN: false,
      selectedAssociation: '',
      associations: []
    };
  },
  methods: {
    next: function next() {
      if (!this.Request.PinNumber) {
        this.noPIN = true;
      } else {
        this.submitted = true;
        this.noPIN = false;
        this.$emit('next');
      }
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    setTenant: function setTenant(key) {
      for (var i = 0; i < this.associations.length; i++) {
        if (this.associations[i].key === key) {
          this.$emit('tenantSelected', this.associations[i].tenant);
        }
      }
    },
    getNestedArray: function getNestedArray(obj) {
      var arr = [];
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var arrayItem = obj[key];
          arrayItem.key = key;
          arr.push(arrayItem);
        }
      }
      return arr;
    },
    getFlatArray: function getFlatArray(obj, tenant) {
      var arr = [];
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var associationName = obj[key];
          var item = {
            key: key,
            label: associationName,
            tenant: tenant
          };
          arr.push(item);
        }
      }
      return arr;
    }
  },
  created: function created() {
    if (this.agencies) {
      var agenciesArray = this.getNestedArray(this.agencies);
      for (var i = 0; i < agenciesArray.length; i++) {
        var assocs = this.getFlatArray(agenciesArray[i].associations, agenciesArray[i].key);
        this.associations = this.associations.concat(assocs);
      }
    }
  }
});

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_246bbd84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("H1VY");
function injectStyle (ssrContext) {
  __webpack_require__("4jZn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-246bbd84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_246bbd84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rA7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title is-4"
  }, [_vm._v("Welcome")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Thank you for registering, you are now logged in.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n            Read our Getting Started documentation for information about managing associations and direct link requests.\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/documentation"
    }
  }, [_vm._v("Getting Started")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n            Start managing associations and generating certificates.\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link is-outlined",
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v("Manage Associations")])], 1)])])]), _vm._v(" "), _c('Footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rgl/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-width": "980px"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container content",
    staticStyle: {
      "padding": "0px 0px 20px 555px",
      "width": "894px",
      "border-bottom": "1px solid lightgrey"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin fa-lg opaque",
    staticStyle: {
      "margin-left": "290px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.isIE) ? _c('a', {
    ref: "pdfIE"
  }, [_c('button', {
    staticClass: "button is-link"
  }, [_vm._v("\n                Download Insurance Certificate (PDF)\n                "), (!_vm.loading) ? _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isIE) ? _c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }, [_c('button', {
    staticClass: "button is-link"
  }, [_vm._v("\n                Download Insurance Certificate (PDF)\n                "), (!_vm.loading) ? _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.association.Attachments && _vm.association.Attachments.length > 0) ? _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "20px",
      "max-width": "330px",
      "word-break": "break-all"
    }
  }, [_c('h4', [_vm._v("Additional Declarations")]), _vm._v(" "), _c('ul', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px",
      "margin-bottom": "0px"
    }
  }, _vm._l((_vm.association.Attachments), function(attachment) {
    return _c('li', [_c('a', {
      attrs: {
        "href": attachment.downloadURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.fileName))])])
  }))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Accord24', {
    ref: "accord",
    attrs: {
      "readonly": true,
      "accord24": _vm.accord24
    }
  })], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t5b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n        Evidence of Insurance Status\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('p', [_vm._v("Your Evidence of Insurance is ready for download. Provide this form as Evidence of Homeowners Insurance to your bank as needed for your mortage banking needs.")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": "/static/ACCORD-EOI.pdf"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_vm._v("ACOORD-EOI.pdf")])])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vatg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LenderInformation',
  props: ['Request'],
  data: function data() {
    return {
      submitted: false,
      found: false
    };
  },
  methods: {
    next: function next() {
      this.submitted = true;
      this.found = false;
      this.$emit('next');
    },
    previous: function previous() {
      this.$emit('previous');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ "vcQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container page-top"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-three-quarters"
  }, [_c('span', {
    staticClass: "title is-5"
  }, [_vm._v("Manage Associations")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link mobile-button",
    attrs: {
      "to": "/associations/new"
    }
  }, [_vm._v("New")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter hide-mobile"
  }, [_c('div', {
    staticClass: "field list-buttons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-link",
    attrs: {
      "to": "/associations/new"
    }
  }, [_vm._v("Create Association")])], 1)])])]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container"
  }, [_c('hr'), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-three-quarters-desktop"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.associations), function(assoc, index) {
    return _c('tr', {
      key: assoc.key
    }, [_c('td', [_c('router-link', {
      staticClass: "has-text-info",
      attrs: {
        "to": '/associations/' + assoc.key
      }
    }, [_vm._v(_vm._s(assoc.Name))])], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "is-pulled-right",
      domProps: {
        "innerHTML": _vm._s(_vm.getStatus(assoc.Status))
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30px"
      }
    }, [_c('div', {
      staticClass: "is-pulled-right"
    }, [_c('div', {
      ref: 'associationRow' + index,
      refInFor: true,
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-trigger"
    }, [_c('div', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.away),
        expression: "away"
      }],
      staticClass: "icon is-small fa-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleActive('associationRow' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "id": "dropdown-menu3",
        "role": "menu"
      }
    }, [_c('div', {
      staticClass: "dropdown-content"
    }, [_c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.openCopyModal(index)
        }
      }
    }, [_vm._v("\n                            Cppy Association\n                          ")]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.openDeleteModal(index)
        }
      }
    }, [_vm._v("\n                            Delete Association\n                          ")])])])])])])])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showDeleteModal) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('h5', [_vm._v("Enter DELETE below to permanently delete " + _vm._s(_vm.associations[_vm.deleteIndex].Name) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin": "-20px 0px 30px 0px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteText),
      expression: "deleteText"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter DELETE"
    },
    domProps: {
      "value": (_vm.deleteText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.deleteText = $event.target.value
      }, function($event) {
        _vm.checkDeleteText(_vm.deleteText)
      }]
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": _vm.disableDeleteContinue
    },
    on: {
      "click": function($event) {
        _vm.deleteAssociation(_vm.deleteIndex)
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.showCopyModal) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showCopyModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.showCopyModal = false
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyData.newAssociationName),
      expression: "copyData.newAssociationName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "New Association Name"
    },
    domProps: {
      "value": (_vm.copyData.newAssociationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.copyData, "newAssociationName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.copyAssociation(_vm.copyIndex, _vm.copyData.newAssociationName)
      }
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showCopyModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vpE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer__ = __webpack_require__("ODK2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: '',
      errorMessage: ''
    };
  },
  methods: {
    login: function login(email, password) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].app.auth().signInWithEmailAndPassword(email, password).then(function () {
        var param = _this.$route.query['redir'];
        var toPath = decodeURIComponent(param);
        if (param) {
          _this.$router.push(toPath);
        } else {
          _this.$router.push('/');
        }
      }).catch(function (error) {
        console.log(error);
        _this.errorMessage = 'Error logging in, please try again.';
      });
    },
    cancel: function cancel() {
      this.$router.push('/');
    }
  },
  components: {
    Footer: __WEBPACK_IMPORTED_MODULE_1__Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "w/5r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      openDropdownRef: {},
      user: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].app.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.user = user;
        // this.setSampleAssociation()
      }
    });
    if (this.$route.query['setTenant']) {
      window.sessionStorage.setItem('tenantName', this.$route.query['setTenant']);
    }
  },
  methods: {
    logout: function logout() {
      var _this2 = this;

      this.$router.push('/');
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].app.auth().signOut().then(function () {
        window.sessionStorage.removeItem('tenantName');
        _this2.user = {};
      });
    },
    away: function away() {
      if (this.openDropdownRef.classList) {
        this.openDropdownRef.classList.remove('is-active');
        this.openDropdownRef = {};
      }
    },
    toggleActive: function toggleActive(ref) {
      if (this.openDropdownRef.classList) {
        this.away();
        return;
      }
      if (this.$refs[ref]) {
        this.openDropdownRef = this.$refs[ref];
        this.openDropdownRef.classList.add('is-active');
      }
    },
    setSampleAssociation: function setSampleAssociation() {
      console.log('test set sample');
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].initialize().then(function () {
        __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('agencies/coastig/associations/-Kz6O2YyO3dJJ3VCeBqg').once('value').then(function (snapshot) {
          var sampleAssociation = snapshot.val();
          __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].firebaseDb.ref('agencies/southerncoastig/associations').push(sampleAssociation);
        });
      });
    }
  }
});

/***/ }),

/***/ "z5VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tenant__ = __webpack_require__("Swjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_associations_Accord24__ = __webpack_require__("DQXn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_accord_util__ = __webpack_require__("+zJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestViewer',
  data: function data() {
    return {
      isLoading: true,
      isSaving: false,
      isGeneratingPdf: false,
      showEmailModal: false,
      emailSuccess: false,
      emailError: false,
      emailInvalidTo: false,
      emailInvalidCc: false,
      isSendingEmail: false,
      emailData: {
        to: '',
        cc: '',
        message: null
      },
      request: {},
      fileName: '',
      pdflink: '',
      accord24: {}
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].initialize().then(function () {
      _this.initialize(_this.$route);
    });
  },
  methods: {
    initialize: function initialize(route) {
      window.document.title = 'View Request';
      this.fetchRequest(route.params.id);
    },
    fetchRequest: function fetchRequest(Id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests/' + Id).once('value').then(function (snapshot) {
        _this2.request = snapshot.val();
        _this2.accord24 = _this2.request.Association.Accord24;
        if (_this2.accord24.AdditionalRemarks) {
          _this2.accord24.AdditionalRemarks = _this2.accord24.AdditionalRemarks.replace(/<br>/gi, '\n');
        }
        _this2.isLoading = false;
      });
    },
    putRequest: function putRequest(request) {
      var _this3 = this;

      var key = this.$route.params.id;
      this.isSaving = true;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests/' + key).set(request).then(function () {
        _this3.isSaving = false;
      });
    },
    getPdf: function getPdf() {
      var _this4 = this;

      this.isGeneratingPdf = true;

      // go ahead and do a save
      var key = this.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_0__tenant__["a" /* default */].ref('requests/' + key).set(this.request);

      var accordForm = this.$refs['accord'].$el.innerHTML;
      var rawHTML = this.getAccordDOM(accordForm);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("" + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        _this4.isGeneratingPdf = false;
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf');
        } else {
          _this4.pdflink = window.URL.createObjectURL(blob);
          _this4.fileName = 'InsuranceCertificate.pdf';
          _this4.$nextTick(function () {
            _this4.$refs['pdf'].click();
          });
        }
      }).catch(function (error) {
        _this4.isGeneratingPdf = false;
        console.log(error);
      });
    },
    getAccordDOM: function getAccordDOM(accordForm) {
      return __WEBPACK_IMPORTED_MODULE_2__utilities_accord_util__["a" /* default */].getAccordDOM(accordForm);
    },
    getAttachmentName: function getAttachmentName() {
      var name = this.request.Association.Name;
      name = name.replace(/ /g, '');
      name = name.replace(/,/g, '');
      return name + '_COI.pdf';
    },
    openEmailModal: function openEmailModal() {
      if (!this.emailData.message) {
        this.emailData.message = 'Please see attached Certificate of Insurance for ' + this.request.Association.Name + '.';
        this.showEmailModal = true;
      } else {
        this.showEmailModal = true;
      }
    },
    closeEmailModal: function closeEmailModal() {
      this.showEmailModal = false;
      this.emailSuccess = false;
      this.emailError = false;
    },
    validateEmailForm: function validateEmailForm(emailData) {
      var foundError = false;
      var to = emailData.to;
      if (!to || to.indexOf('@') < 1 || to.indexOf('.') < 2) {
        this.emailInvalidTo = true;
        foundError = true;
      } else {
        this.emailInvalidTo = false;
      }

      var cc = emailData.cc;
      if (cc && (cc.indexOf('@') < 1 || cc.indexOf('.') < 2)) {
        this.emailInvalidCc = true;
        foundError = true;
      } else {
        this.emailInvalidCc = false;
      }

      if (foundError) {
        return false;
      }

      return true;
    },
    sendEmailMessage: function sendEmailMessage(emailData) {
      var _this5 = this;

      if (!this.validateEmailForm(emailData)) {
        return;
      }
      var accordForm = this.$refs['accord'].$el.innerHTML;
      emailData.rawHTML = this.getAccordDOM(accordForm);
      emailData.subject = 'Certificate of Insurance for ' + this.request.Association.Name;
      emailData.attachmentName = this.getAttachmentName();
      if (emailData.message.indexOf('https://www.getcoi.com') < 0) {
        emailData.message += '\n\n\n\n_____________________________\n\nThis certificate was provided by GetCOI. We help independent insurance brokers automate certificate of insurance requests.\nhttps://www.getcoi.com\n        ';
      }

      this.isSendingEmail = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("" + '/api/certificates/email-pdf', emailData).then(function (response) {
        _this5.emailSuccess = true;
        _this5.isSendingEmail = false;
      }).catch(function (error) {
        _this5.isSendingEmail = false;
        _this5.emailError = true;
        console.log(error);
      });
    },
    cancel: function cancel() {
      this.$router.push('/requests');
    }
  },
  watch: {
    '$route': function $route() {
      this.initialize(this.$route);
    },

    floatResearch: function floatResearch() {
      this.researchScroll();
    }
  },
  components: {
    Accord24: __WEBPACK_IMPORTED_MODULE_1__components_associations_Accord24__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.36e0e25ccf9275d3d3a4.js